/**
 * Gild Group product configurator — optionset API, pricing, cart/add.js
 * Loaded after jQuery on the main product section.
 */
(function ($) {
  'use strict';

  var AUTH = {
    Authorization:
      'Bearer bHhxZHZmNGhrMDZsZXRtbHRlOXU1dHllYnRycGpsdnM='
  };

  function gildApiUrl(endpoint) {
    return 'https://d2dcooptions.com/api/' + endpoint;
  }

  var API_OPTIONS = gildApiUrl('optionsetapi');
  var API_STYLE = gildApiUrl('optionstyleapi');

  function gildApiPost(url, data) {
    return $.ajax({
      url: url,
      type: 'POST',
      dataType: 'text',
      headers: AUTH,
      data: data,
      crossDomain: true,
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          'Authorization',
          AUTH.Authorization
        );
      }
    }).then(function (text) {
      if (
        typeof text === 'string' &&
        /^\s*</.test(text)
      ) {
        return $.Deferred()
          .reject({
            responseText:
              'Configurator API returned an HTML error page'
          })
          .promise();
      }

      return text;
    });
  }

  var id =
    Math.floor(
      Math.random() * 9999999 + 1
    );

  var main_div_arr = [];
  var temp_div_arr = [];
  var productId = '';
  var single_door_flag = 1;
  var count_odd_even = 0;
  var prsetid = 0;

  var ass_pro_val_field = '0.00';
  var orig_pro_field = '';
  var orig_proc_field = '';
  var main_pr = '';
  var productPriceCompareCustom = '';
  var hasOriginalComparePrice = false;
  var unitBasePrice = 0;
  var unitComparePrice = 0;
  var extra_value = 0;
  var extra_price = 0;
  var tot = 0;
  var totc = 0;

  var currentOptionsResponse = null;
  var lastVariantFromPicker = null;
  var hasGildConfiguration = false;

  var gildSwatchSuppressChange = false;
  var gildSwatchNavTimeout = null;
  var gildSwatchPendingRadio = null;

  var shopifyVariantPriceCache = {};
  var shopifyVariantPriceLoadPromise = null;

  var doorConfigurationOptionIndex = 0;
  var optionsRequestToken = 0;
  var pendingConfiguratorLoad = false;
  var configuratorApiProductId = '';
  var loadOptionsetTimer = null;

  /* ============================================================
   * BASIC / API HELPERS
   * ============================================================ */

  function isDoorConfigurationOptionName(optionName) {
    return /door configuration|configuration type|single\s*\/\s*double/i.test(
      String(optionName || '').trim()
    );
  }

  function optionValuesIncludeDoorConfigurationChoices(opt) {
    if (!opt || !opt.option_values) return false;

    var values = normalizeOptionValues(
      opt.option_values
    );

    for (var i = 0; i < values.length; i++) {
      var rawValue = String(
        values[i].option_value || ''
      )
        .replace(
          /\s*\[\+\s*[^\]]+\]\s*$/i,
          ''
        )
        .replace(/\s+/g, ' ')
        .trim();

      if (
        /^(single door|double door|none)$/i.test(
          rawValue
        )
      ) {
        return true;
      }
    }

    return false;
  }

  function resolveDoorConfigurationOptionIndex(response) {
    if (!response || !response.options) {
      return 0;
    }

    var optionsLength =
      Object.keys(response.options).length;

    for (var i = 0; i < optionsLength; i++) {
      if (
        isDoorConfigurationOptionName(
          response.options[i].option_name
        )
      ) {
        return i;
      }
    }

    for (var j = 0; j < optionsLength; j++) {
      if (
        optionValuesIncludeDoorConfigurationChoices(
          response.options[j]
        )
      ) {
        return j;
      }
    }

    return 0;
  }

  function getDoorConfigurationOptionIndex() {
    if (
      currentOptionsResponse &&
      currentOptionsResponse.options
    ) {
      return resolveDoorConfigurationOptionIndex(
        currentOptionsResponse
      );
    }

    return doorConfigurationOptionIndex;
  }

  function doorConfigurationSelectId() {
    return 'C' + getDoorConfigurationOptionIndex();
  }

  function revealConfiguratorPanel() {
    var $panel = $('#api-response');

    $panel.show().css({
      display: 'block',
      visibility: 'visible'
    });
  }

  function showConfiguratorLoadingState() {
    revealConfiguratorPanel();

    $('#api-response').html(
      '<p class="configuration-option-loading" role="status">Loading door configuration…</p>'
    );
  }

  function showConfiguratorUnavailableState(message) {
    if (
      String(message || '').trim() ===
      'Unable to load door configuration. Please refresh and try again.'
    ) {
      $('#api-response').hide();
      return;
    }
    revealConfiguratorPanel();

    $('#api-response').html(
      '<p class="configuration-option-loading" role="status">' +
        escHtml(message) +
        '</p>'
    );
  }

  function isDoorConfigurationEnabled() {
    var $el = $('#product-fst-id');

    if (!$el.length) return false;

    return (
      $el.attr(
        'data-gild-configurator-enabled'
      ) !== 'false'
    );
  }

  function isShopifyCatalogProductId(id) {
    var shopifyProductId =
      getShopifyProductId();

    return (
      shopifyProductId &&
      String(id) === String(shopifyProductId)
    );
  }

  function getMainFormVariantId() {
    var $form =
      $('.js-product-form-main').first();

    if (!$form.length) return '';

    var variantId =
      $form.find('input[name="id"]').val() || '';

    return variantId ? String(variantId) : '';
  }

  function resolveGildVariantId() {
    var variantId = getMainFormVariantId();

    if (
      !variantId &&
      lastVariantFromPicker &&
      lastVariantFromPicker.id != null
    ) {
      variantId =
        String(lastVariantFromPicker.id);
    }

    if (!variantId) {
      variantId =
        $('#product-fst-id').attr(
          'data-initial-variant-id'
        ) || '';
    }

    if (!variantId) {
      variantId = getProductId();
    }

    if (
      isShopifyCatalogProductId(variantId)
    ) {
      return '';
    }

    return variantId ? String(variantId) : '';
  }

  function getGildVariantIdForApi() {
    var variantId =
      resolveGildVariantId();

    if (variantId) {
      $('#product-fst-id').val(variantId);
      productId = variantId;
    }

    return variantId;
  }

  function syncConfiguratorVariantContext() {
    return getGildVariantIdForApi();
  }

  function expandDoorConfigurationRow(response) {
    var doorIndex =
      resolveDoorConfigurationOptionIndex(
        response
      );

    revealConfigurationOption(doorIndex);

    var $doorRow =
      getConfigurationOptionRow(doorIndex);

    if (
      !$doorRow.length ||
      $doorRow.css('display') === 'none'
    ) {
      doorIndex = 0;

      revealConfigurationOption(0);

      $doorRow =
        getConfigurationOptionRow(0);
    }

    if ($doorRow.length) {
      $doorRow.removeClass('is-collapsed');

      $doorRow
        .find(
          '.configuration-option-each__body'
        )
        .removeAttr('hidden');

      $doorRow
        .find(
          '.configuration-option-each__choice'
        )
        .text('');

      $doorRow
        .find(
          '.configuration-option-toggle'
        )
        .attr('aria-expanded', 'true');
    }

    revealConfiguratorPanel();
  }

  function getProductId() {
    var $el =
      $('#product-fst-id');

    return $el.length
      ? String($el.val() || '')
      : '';
  }

  function getShopifyProductId() {
    var $el =
      $('#product-fst-id');

    if (!$el.length) return '';

    var shopifyProductId =
      $el.attr(
        'data-shopify-product-id'
      );

    return shopifyProductId
      ? String(shopifyProductId)
      : '';
  }

  function getConfiguratorApiProductId() {
    if (
      configuratorApiProductId &&
      !isShopifyCatalogProductId(
        configuratorApiProductId
      )
    ) {
      return String(
        configuratorApiProductId
      );
    }

    return getGildVariantIdForApi();
  }

  function normalizeOptionValues(optionValues) {
    if (!optionValues) return [];

    if (Array.isArray(optionValues)) {
      return optionValues.filter(
        function (value) {
          return (
            value &&
            typeof value ===
              'object'
          );
        }
      );
    }

    if (
      typeof optionValues ===
      'object'
    ) {
      return Object.keys(optionValues)
        .map(function (key) {
          return optionValues[key];
        })
        .filter(function (value) {
          return (
            value &&
            typeof value ===
              'object'
          );
        });
    }

    return [];
  }

  function normalizeOptionsResponse(response) {
    if (
      !response ||
      typeof response !== 'object'
    ) {
      return response;
    }

    var list = [];

    if (Array.isArray(response.options)) {
      list =
        response.options.slice();
    } else if (
      response.options &&
      typeof response.options ===
        'object'
    ) {
      Object.keys(response.options).forEach(
        function (key) {
          list.push(
            response.options[key]
          );
        }
      );
    }

    response.options =
      list
        .filter(function (opt) {
          return (
            opt &&
            typeof opt ===
              'object'
          );
        })
        .map(function (opt) {
          var normalized =
            Object.assign({}, opt);

          normalized.option_values =
            normalizeOptionValues(
              opt.option_values
            );

          return normalized;
        });

    return response;
  }

  function parseGildOptionsResponse(raw) {
    var response = raw;

    if (typeof raw === 'string') {
      try {
        response = JSON.parse(raw);
      } catch (e) {
        return null;
      }
    }

    if (
      !response ||
      typeof response !== 'object'
    ) {
      return null;
    }

    if (
      Array.isArray(response) &&
      response.length
    ) {
      response = response[0];
    }

    if (
      !response.options &&
      response.data &&
      response.data.options
    ) {
      response = Object.assign(
        {},
        response,
        response.data
      );
    }

    if (
      !response.options &&
      response.result &&
      response.result.options
    ) {
      response = Object.assign(
        {},
        response,
        response.result
      );
    }

    return normalizeOptionsResponse(
      response
    );
  }

  function gildFlag(value) {
    var normalized = String(
      value == null ? '' : value
    )
      .trim()
      .toUpperCase();

    return (
      normalized === 'Y' ||
      normalized === 'YES' ||
      normalized === '1' ||
      normalized === 'TRUE'
    );
  }

  function getGildResponseError(response) {
    if (
      !response ||
      typeof response !== 'object'
    ) {
      return 'No configurator response';
    }

    if (response.response_message) {
      var msg =
        String(
          response.response_message
        ).trim();

      if (!msg) return '';

      if (
        /^(success|ok|successful)/i.test(msg)
      ) {
        return '';
      }

      if (
        /authentication|please provide|unauthorized|invalid token|error|fail/i.test(
          msg
        )
      ) {
        return msg;
      }

      if (
        response.options &&
        response.options.length
      ) {
        return '';
      }

      return msg;
    }

    if (
      response.status === 'error' &&
      response.message
    ) {
      return String(
        response.message
      );
    }

    return '';
  }

  function getOptionsCount(response) {
    if (
      !response ||
      !response.options
    ) {
      return 0;
    }

    if (
      Array.isArray(response.options)
    ) {
      return response.options.length;
    }

    return Object.keys(
      response.options
    ).length;
  }

  function shopCurrency() {
    return (
      $('#shop-currency').val() ||
      ''
    );
  }

  function escHtml(str) {
    if (str == null) return '';

    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function htmlToPlainText(str) {
    if (str == null) return '';

    var s = String(str).replace(
      /<br\s*\/?>/gi,
      ' '
    );

    var div =
      document.createElement('div');

    div.innerHTML = s;

    return (
      div.textContent ||
      div.innerText ||
      ''
    )
      .replace(
        /\*\*([^*]+)\*\*/g,
        '$1'
      )
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* ============================================================
   * HELP POPOVERS
   * ============================================================ */

  function getConfigHelpLabel(optionName) {
    var template =
      $('#api-response').attr(
        'data-config-help-label'
      ) ||
      'More information about __OPTION_NAME__';

    return template.replace(
      /__OPTION_NAME__/g,
      optionName
    );
  }

  function getConfigHelpCloseLabel() {
    return (
      $('#api-response').attr(
        'data-config-help-close-label'
      ) || 'Close'
    );
  }

  function supportsPopover() {
    return (
      typeof HTMLElement.prototype
        .showPopover ===
      'function'
    );
  }

  var helpPopoverRepositionHandler =
    null;

  function positionConfigurationHelpPopover(
    popover,
    btn
  ) {
    if (!popover || !btn) return;

    var titleRow =
      btn.closest(
        '.configuration-option-each__title-row'
      );

    var anchorRect = titleRow
      ? titleRow.getBoundingClientRect()
      : btn.getBoundingClientRect();

    var gap = 4;
    var viewportPadding = 16;
    var popoverWidth =
      popover.offsetWidth;
    var popoverHeight =
      popover.offsetHeight;

    if (!popoverWidth) {
      popoverWidth =
        Math.min(
          320,
          window.innerWidth -
            viewportPadding * 2
        );
    }

    var top =
      anchorRect.bottom + gap;

    var left =
      anchorRect.right -
      popoverWidth;

    if (
      popoverHeight &&
      top +
        popoverHeight >
        window.innerHeight -
          viewportPadding
    ) {
      var aboveTop =
        anchorRect.top -
        popoverHeight -
        gap;

      if (
        aboveTop >=
        viewportPadding
      ) {
        top = aboveTop;
      }
    }

    var stickyHeader =
      document.querySelector(
        'store-header.header'
      );

    if (stickyHeader) {
      var headerBottom =
        stickyHeader
          .getBoundingClientRect()
          .bottom;

      if (
        top <
        headerBottom + gap
      ) {
        top =
          headerBottom + gap;
      }
    }

    left = Math.max(
      viewportPadding,
      Math.min(
        left,
        window.innerWidth -
          viewportPadding -
          popoverWidth
      )
    );

    if (popoverHeight) {
      top = Math.max(
        viewportPadding,
        Math.min(
          top,
          window.innerHeight -
            viewportPadding -
            popoverHeight
        )
      );
    }

    popover.style.top =
      top + 'px';

    popover.style.left =
      left + 'px';
  }

  function repositionOpenHelpPopovers() {
    $(
      '#api-response .configuration-option-help-popover'
    ).each(function () {
      var popover = this;

      if (
        !popover.matches(
          ':popover-open'
        )
      ) {
        return;
      }

      var btn =
        document.querySelector(
          '[popovertarget="' +
            popover.id +
            '"]'
        );

      if (btn) {
        positionConfigurationHelpPopover(
          popover,
          btn
        );
      }
    });
  }

  function ensureHelpPopoverRepositionListeners() {
    if (
      helpPopoverRepositionHandler ||
      !supportsPopover()
    ) {
      return;
    }

    helpPopoverRepositionHandler =
      function () {
        repositionOpenHelpPopovers();
      };

    window.addEventListener(
      'resize',
      helpPopoverRepositionHandler
    );

    window.addEventListener(
      'scroll',
      helpPopoverRepositionHandler,
      true
    );
  }

  function closeAllHelpPopovers() {
    $(
      '#api-response .configuration-option-help-popover'
    ).each(function () {
      var popover = this;

      if (
        supportsPopover() &&
        popover.matches(
          ':popover-open'
        )
      ) {
        popover.hidePopover();
      } else if (
        popover.getAttribute(
          'data-open'
        ) === 'true'
      ) {
        popover.removeAttribute(
          'data-open'
        );

        popover.hidden = true;
      }
    });

    $(
      '#api-response .configuration-option-help-btn'
    ).attr(
      'aria-expanded',
      'false'
    );
  }

  function initConfigurationHelpPopovers() {
    closeAllHelpPopovers();
    ensureHelpPopoverRepositionListeners();

    $(
      '#api-response .configuration-option-help-popover'
    ).each(function () {
      var popover = this;

      var btn =
        document.querySelector(
          '[popovertarget="' +
            popover.id +
            '"]'
        );

      if (
        btn &&
        !popover.dataset
          .helpToggleBound
      ) {
        popover.addEventListener(
          'toggle',
          function (event) {
            btn.setAttribute(
              'aria-expanded',
              event.newState === 'open'
                ? 'true'
                : 'false'
            );

            if (
              !supportsPopover()
            ) {
              return;
            }

            if (
              event.newState ===
              'open'
            ) {
              requestAnimationFrame(
                function () {
                  positionConfigurationHelpPopover(
                    popover,
                    btn
                  );

                  requestAnimationFrame(
                    function () {
                      positionConfigurationHelpPopover(
                        popover,
                        btn
                      );
                    }
                  );
                }
              );
            } else {
              popover.style.removeProperty(
                'top'
              );

              popover.style.removeProperty(
                'left'
              );
            }
          }
        );

        popover.dataset.helpToggleBound =
          'true';
      }

      if (
        supportsPopover()
      ) {
        popover.removeAttribute(
          'hidden'
        );
      } else {
        popover.hidden = true;
      }
    });

    if (supportsPopover()) {
      return;
    }

    $(document)
      .off(
        'click.gildHelp',
        '.configuration-option-help-btn'
      )
      .on(
        'click.gildHelp',
        '.configuration-option-help-btn',
        function (e) {
          e.preventDefault();
          e.stopPropagation();

          var targetId =
            $(this).attr(
              'popovertarget'
            );

          var popover =
            document.getElementById(
              targetId
            );

          if (!popover) return;

          var isOpen =
            popover.getAttribute(
              'data-open'
            ) === 'true';

          closeAllHelpPopovers();

          if (!isOpen) {
            popover.hidden = false;

            popover.setAttribute(
              'data-open',
              'true'
            );

            $(this).attr(
              'aria-expanded',
              'true'
            );
          }
        }
      );

    $(document)
      .off(
        'click.gildHelpClose',
        '.configuration-option-help-popover__close'
      )
      .on(
        'click.gildHelpClose',
        '.configuration-option-help-popover__close',
        function (e) {
          e.preventDefault();
          e.stopPropagation();

          closeAllHelpPopovers();
        }
      );

    $(document)
      .off('click.gildHelpDismiss')
      .on(
        'click.gildHelpDismiss',
        function (e) {
          if (
            $(e.target).closest(
              '.configuration-option-help-btn, .configuration-option-help-popover'
            ).length
          ) {
            return;
          }

          closeAllHelpPopovers();
        }
      );

    $(document)
      .off('keydown.gildHelp')
      .on(
        'keydown.gildHelp',
        function (e) {
          if (e.key === 'Escape') {
            closeAllHelpPopovers();
          }
        }
      );
  }

  /* ============================================================
   * COLLAPSIBLE OPTIONS
   * ============================================================ */

  function getOptionRowSummary($row) {
    var $sel =
      $row.find(
        'select.configuration-option-dropdown'
      );

    if ($sel.length) {
      var v = $sel.val();

      if (!v) return '';

      var t =
        $sel.find(':selected').text() || '';

      return t
        .replace(
          /\s*\[\+\s*[^\]]+\]\s*$/,
          ''
        )
        .trim();
    }

    var $sw =
      $row.find(
        '.custom-swatches:checked'
      );

    if ($sw.length) {
      var vSw =
        $sw.val();

      if (vSw) {
        return String(vSw)
          .replace(
            /\s*\[\+\s*[^\]]+\]\s*$/,
            ''
          )
          .trim();
      }
    }

    var parts = [];

    $row
      .find(
        '.custom-checkboxes:checked'
      )
      .each(function () {
        parts.push($(this).val());
      });

    if (parts.length) {
      return parts.join(', ');
    }

    var $st =
      $row.find(
        '.custom-shorttext'
      );

    if ($st.length) {
      var tv =
        ($st.val() || '').trim();

      if (tv) {
        return tv;
      }
    }

    var $span =
      $row.find(
        '.custom-text-span'
      );

    if ($span.length) {
      var st =
        ($span.text() || '').trim();

      if (st) {
        return st;
      }
    }

    var $ro =
      $row.find(
        'input.custom-text'
      );

    if ($ro.length) {
      return (
        $ro.val() || ''
      ).trim();
    }

    return '';
  }

  function setRowCollapsed(
    $row,
    collapsed
  ) {
    var $btn =
      $row
        .find(
          '.configuration-option-toggle'
        )
        .first();

    var $choice =
      $row.find(
        '.configuration-option-each__choice'
      );

    var $body =
      $row
        .find(
          '.configuration-option-each__body'
        )
        .first();

    if (collapsed) {
      var summary =
        getOptionRowSummary(
          $row
        );

      if (!summary) return;

      var activeEl =
        document.activeElement;

      var focusWasInBody =
        $body.length &&
        activeEl &&
        $body[0].contains(
          activeEl
        );

      $row.addClass(
        'is-collapsed'
      );

      $body.attr(
        'hidden',
        ''
      );

      $choice.text(
        summary
      );

      $btn.attr(
        'aria-expanded',
        'false'
      );

      if (
        focusWasInBody &&
        $btn[0]
      ) {
        $btn[0].focus({
          preventScroll:
            true
        });
      }
    } else {
      $row.removeClass(
        'is-collapsed'
      );

      $body.removeAttr(
        'hidden'
      );

      $choice.text('');

      $btn.attr(
        'aria-expanded',
        'true'
      );
    }
  }

  function scheduleSwatchCollapseCheck($row) {
    if (!$row.length) return;

    var body =
      $row.find(
        '.configuration-option-each__body'
      )[0];

    setTimeout(function () {
      if (
        body &&
        body.contains(
          document.activeElement
        )
      ) {
        return;
      }

      if ($row[0]) {
        delete $row[0]
          .dataset
          .keyboardNavigating;
      }

      tryCollapseOnChange($row);
    }, 0);
  }

  function flushPendingSwatchUpdate() {
    clearTimeout(
      gildSwatchNavTimeout
    );

    gildSwatchNavTimeout =
      null;

    if (!gildSwatchPendingRadio) {
      return;
    }

    var radio =
      gildSwatchPendingRadio;

    var focusId =
      radio.id;

    gildSwatchPendingRadio =
      null;

    var $row =
      $(radio).closest(
        '.configuration-option-each'
      );

    if ($row[0]) {
      delete $row[0]
        .dataset
        .keyboardNavigating;
    }

    gildSwatchSuppressChange =
      false;

    $(radio).trigger(
      'change'
    );

    tryCollapseOnChange(
      $row
    );

    setTimeout(function () {
      var el =
        focusId &&
        document.getElementById(
          focusId
        );

      if (el) {
        el.focus({
          preventScroll:
            true
        });
      }
    }, 0);
  }

  function markSwatchKeyboardNavigationActive(
    $row
  ) {
    if ($row[0]) {
      $row[0].dataset.keyboardNavigating =
        'true';
    }

    clearTimeout(
      gildSwatchNavTimeout
    );
  }

  function endSwatchKeyboardNavigation(
    $body
  ) {
    if (!$body.length) return;

    var active =
      document.activeElement;

    if (
      $body[0].contains(active)
    ) {
      return;
    }

    flushPendingSwatchUpdate();
  }

  function queueSwatchUpdate(
    radio,
    $row
  ) {
    gildSwatchPendingRadio =
      radio;

    markSwatchKeyboardNavigationActive(
      $row
    );
  }

  function selectSwatchOption(radio) {
    gildSwatchSuppressChange =
      true;

    radio.checked = true;

    var $card =
      $(radio).closest(
        '.configuration-swatch-card, .box'
      );

    if ($card.length) {
      $card[0].scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }

  function initSwatchKeyboardNavigation() {
    $(document)
      .off(
        'keydown.gildSwatchKb',
        '#api-response .custom-swatches'
      )
      .on(
        'keydown.gildSwatchKb',
        '#api-response .custom-swatches',
        function (e) {
          var forward =
            e.key === 'ArrowRight' ||
            e.key === 'ArrowDown';

          var backward =
            e.key === 'ArrowLeft' ||
            e.key === 'ArrowUp';

          if (
            !forward &&
            !backward
          ) {
            return;
          }

          var radio = this;

          var $body =
            $(radio).closest(
              '.configuration-option-each__body'
            );

          var $row =
            $body.closest(
              '.configuration-option-each'
            );

          if (
            !$body.length ||
            $body.is('[hidden]')
          ) {
            return;
          }

          var radios =
            $body
              .find(
                'input.custom-swatches'
              )
              .filter(function () {
                return (
                  this.name ===
                    radio.name &&
                  !this.disabled
                );
              })
              .get();

          var idx =
            radios.indexOf(radio);

          if (idx === -1) return;

          var nextIdx =
            idx +
            (forward ? 1 : -1);

          if (
            nextIdx < 0 ||
            nextIdx >= radios.length
          ) {
            e.preventDefault();
            e.stopImmediatePropagation();

            return;
          }

          e.preventDefault();
          e.stopImmediatePropagation();

          var next =
            radios[nextIdx];

          next.focus({
            preventScroll:
              true
          });

          if (next !== radio) {
            selectSwatchOption(next);
            queueSwatchUpdate(
              next,
              $row
            );
          } else {
            markSwatchKeyboardNavigationActive(
              $row
            );
          }
        }
      );

    $(document)
      .off(
        'focusout.gildSwatchKb',
        '#api-response .configuration-option-each__body'
      )
      .on(
        'focusout.gildSwatchKb',
        '#api-response .configuration-option-each__body',
        function () {
          var $body =
            $(this);

          setTimeout(function () {
            if (
              $body[0].contains(
                document.activeElement
              )
            ) {
              return;
            }

            endSwatchKeyboardNavigation(
              $body
            );

            scheduleSwatchCollapseCheck(
              $body.closest(
                '.configuration-option-each'
              )
            );
          }, 0);
        }
      );

    $(document)
      .off(
        'keyup.gildSwatchKb',
        '#api-response .configuration-option-each__body'
      )
      .on(
        'keyup.gildSwatchKb',
        '#api-response .configuration-option-each__body',
        function (e) {
          if (
            e.key !== 'ArrowUp' &&
            e.key !== 'ArrowDown' &&
            e.key !== 'ArrowLeft' &&
            e.key !== 'ArrowRight'
          ) {
            return;
          }

          var $row =
            $(this).closest(
              '.configuration-option-each'
            );

          markSwatchKeyboardNavigationActive(
            $row
          );
        }
      );
  }

  function tryCollapseOnChange($row) {
    if (
      $row[0] &&
      $row[0]
        .dataset
        .keyboardNavigating ===
        'true'
    ) {
      return;
    }

    var summary =
      getOptionRowSummary($row);

    if (summary) {
      setRowCollapsed(
        $row,
        true
      );
    } else {
      setRowCollapsed(
        $row,
        false
      );
    }
  }

  function initCollapsibleOptions() {
    var doorIndex =
      getDoorConfigurationOptionIndex();

    $(
      '#api-response .configuration-option-each'
    ).each(function () {
      var $row = $(this);

      var rowIndex =
        parseInt(
          $row.attr(
            'data-option-index'
          ),
          10
        );

      if (
        rowIndex ===
        doorIndex
      ) {
        expandDoorConfigurationRow(
          currentOptionsResponse || {
            options: []
          }
        );

        return;
      }

      tryCollapseOnChange($row);
    });

    $(document)
      .off(
        'click.gildCollapse',
        '.configuration-option-toggle'
      )
      .on(
        'click.gildCollapse',
        '.configuration-option-toggle',
        function (e) {
          e.preventDefault();

          var $row =
            $(this).closest(
              '.configuration-option-each'
            );

          $row.toggleClass(
            'is-collapsed'
          );

          var collapsed =
            $row.hasClass(
              'is-collapsed'
            );

          var $body =
            $row
              .find(
                '.configuration-option-each__body'
              )
              .first();

          $(this).attr(
            'aria-expanded',
            collapsed
              ? 'false'
              : 'true'
          );

          if (collapsed) {
            $body.attr(
              'hidden',
              ''
            );

            var summary =
              getOptionRowSummary(
                $row
              );

            $row
              .find(
                '.configuration-option-each__choice'
              )
              .text(
                summary || '—'
              );
          } else {
            $body.removeAttr(
              'hidden'
            );

            $row
              .find(
                '.configuration-option-each__choice'
              )
              .text('');
          }
        }
      );

    $(document)
      .off(
        'click.gildCollapseChevron',
        '.configuration-option-chevron'
      )
      .on(
        'click.gildCollapseChevron',
        '.configuration-option-chevron',
        function (e) {
          e.preventDefault();

          $(this)
            .closest(
              '.configuration-option-each'
            )
            .find(
              '.configuration-option-toggle'
            )
            .first()
            .trigger(
              'click'
            );
        }
      );

    $(document)
      .off(
        'change.gildCollapseInput',
        '#api-response'
      )
      .on(
        'change.gildCollapseInput',
        '#api-response select, #api-response .custom-swatches, #api-response .custom-checkboxes',
        function () {
          var $row =
            $(this).closest(
              '.configuration-option-each'
            );

          if (
            $row[0] &&
            $row[0]
              .dataset
              .keyboardNavigating ===
              'true'
          ) {
            return;
          }

          tryCollapseOnChange(
            $row
          );
        }
      );

    $(document)
      .off(
        'blur.gildCollapse',
        '#api-response .custom-shorttext'
      )
      .on(
        'blur.gildCollapse',
        '#api-response .custom-shorttext',
        function () {
          tryCollapseOnChange(
            $(this).closest(
              '.configuration-option-each'
            )
          );
        }
      );

    initSwatchKeyboardNavigation();
  }

  /* ============================================================
   * STYLE / MONEY
   * ============================================================ */

  function applyOptionStyles(data) {
    gildApiPost(
      API_STYLE,
      data
    )
      .done(function (response) {
        if (
          response &&
          typeof response.forEach ===
            'function'
        ) {
          response.forEach(function (item) {
            $('.configuration-option-level').css(
              'font-weight',
              item.option_font_weight
            );

            $('.configuration-option-level').css(
              'font-style',
              item.option_text_style
            );

            $('.configuration-option-level').css(
              'color',
              item.option_font_color
            );

            $('.configuration-option-level').css(
              'font-size',
              item.option_font_size
            );

            $('.configuration-option-level').css(
              'font-family',
              item.option_font_type
            );

            $('.configuration-option-level').css(
              'background-color',
              item.option_label_bg_color
            );

            $('.configuration-option-help-popover__content').css(
              'color',
              item.help_text_font_color
            );

            $('.configuration-option-help-popover__content').css(
              'font-weight',
              item.help_text_font_weight
            );

            $('.configuration-option-help-popover__content').css(
              'font-size',
              item.help_text_font_size
            );

            $('.configuration-option-help-popover__content').css(
              'font-style',
              item.help_text_style
            );

            $('.configuration-option-help-popover__content').css(
              'font-family',
              item.help_text_font_type
            );
          });
        }

        revealConfiguratorPanel();
      })
      .fail(function () {
        revealConfiguratorPanel();
      });
  }

  function parseMoneyAmount(text) {
    if (
      text == null ||
      text === ''
    ) {
      return 0;
    }

    var amount =
      String(text);

    var keyword = '$';

    if (
      amount.indexOf(keyword) !==
      -1
    ) {
      amount =
        amount.substring(
          amount.indexOf(keyword) +
            keyword.length
        );
    }

    amount =
      amount
        .split(']')
        .join('')
        .replace(/\s+/g, '');

    var parsed =
      parseFloat(amount);

    return isNaN(parsed)
      ? 0
      : parsed;
  }

  function formatMoneyAmount(amount) {
    return (
      ' $ ' +
      parseFloat(
        Number(amount)
      ).toFixed(2)
    );
  }

  function formatOptionPriceLabelSuffix(
    variantPrice
  ) {
    if (
      variantPrice == null ||
      variantPrice === ''
    ) {
      return '';
    }

    var priceText =
      String(
        variantPrice
      ).trim();

    if (!priceText) return '';

    if (
      priceText.indexOf('$') !== -1
    ) {
      return (
        ' [+ ' +
        priceText +
        ']'
      );
    }

    return (
      ' [+ ' +
      shopCurrency() +
      priceText +
      ']'
    );
  }

  function isHingeFinishOptionName(
    optionName
  ) {
    if (!optionName) return false;
    var name = String(optionName)
      .replace(/\s*\*+\s*$/, '')
      .trim();

    return /hinge finish$/i.test(name) || /hinge finish/i.test(name);
  }

  function isJambKitFinishSelectorOptionName(
    optionName
  ) {
    if (!optionName) return false;

    return (
      /Jamb Kit \| Finish/i.test(
        optionName
      ) &&
      !/Hinge Finish/i.test(
        optionName
      )
    );
  }

  function isJambKitFinishSelectorOption(
    $optionRow
  ) {
    return isJambKitFinishSelectorOptionName(
      $optionRow
        .find(
          '.configuration-option-title-text'
        )
        .text()
    );
  }

  function normalizeOptionValue(value) {
    return String(
      value == null ? '' : value
    )
      .replace(/\s+/g, ' ')
      .trim();
  }

  function stripOptionValuePriceSuffix(
    value
  ) {
    var str = String(value || '');
    str = str.replace(/\s*\[\+\s*[^\]]+\]\s*$/i, '');
    str = str.replace(/\s*\(\+\s*[^\)]+\)\s*$/i, '');
    str = str.replace(/\s*\+\s*\$?\s*[\d.,]+\s*$/i, '');
    return normalizeOptionValue(str);
  }

  function isPrehangOptionValue(
    value
  ) {
    return (
      /yes,\s*prehang/i.test(
        String(value || '')
      ) ||
      /\brapidhang/i.test(
        String(value || '')
      )
    );
  }

  function optionValuesMatch(
    storedValue,
    selectedValue
  ) {
    var stored =
      normalizeOptionValue(
        storedValue
      );

    var selected =
      normalizeOptionValue(
        selectedValue
      );

    if (stored === selected) {
      return true;
    }

    return (
      stripOptionValuePriceSuffix(
        stored
      ) ===
      stripOptionValuePriceSuffix(
        selected
      )
    );
  }

  function optionAdjustsPrice(
    optionValueData
  ) {
    if (!optionValueData) return false;

    if (
      String(
        optionValueData.adjust_price
      ).toUpperCase() ===
      'Y'
    ) {
      return true;
    }

    if (
      optionValueData.variant_id != null &&
      parseFloat(
        optionValueData.variant_price
      ) > 0
    ) {
      return true;
    }

    return (
      parseIncrementalPrice(
        optionValueData.option_value
      ) != null ||
      parseFloat(
        optionValueData.variant_price
      ) > 0
    );
  }

  function isShopifyVariantPriceCached(
    variantId
  ) {
    if (variantId == null) {
      return true;
    }

    return Object.prototype.hasOwnProperty.call(
      shopifyVariantPriceCache,
      String(variantId)
    );
  }

  function getCachedShopifyVariantPriceDollars(
    variantId
  ) {
    if (
      !isShopifyVariantPriceCached(
        variantId
      )
    ) {
      return null;
    }

    var cached =
      shopifyVariantPriceCache[
        String(variantId)
      ];

    return typeof cached === 'number' &&
      !isNaN(cached)
      ? cached
      : 0;
  }

  function getMainVariantIdForPricing() {
    var variantId =
      getGildVariantIdForApi();

    return variantId || null;
  }

  function collectPricingVariantIds(
    prepared
  ) {
    var ids =
      collectAssociatedVariantIds(
        prepared
      ).map(String);

    var mainVariantId =
      getMainVariantIdForPricing();

    if (
      mainVariantId &&
      ids.indexOf(mainVariantId) === -1
    ) {
      ids.unshift(mainVariantId);
    }

    return ids;
  }

  function needsShopifyPricesForPricing(
    prepared
  ) {
    return collectPricingVariantIds(
      prepared
    ).some(function (variantId) {
      return !isShopifyVariantPriceCached(
        variantId
      );
    });
  }

  function sumCachedShopifyCompanionPrices(
    companionVariantIds
  ) {
    var total = 0;

    (
      companionVariantIds || []
    ).forEach(function (variantId) {
      var price =
        getCachedShopifyVariantPriceDollars(
          variantId
        );

      if (price != null) {
        total += price;
      }
    });

    return total;
  }

  function isCompanionVariantPriceResolved(
    variantId,
    prepared
  ) {
    return isShopifyVariantPriceCached(
      variantId
    );
  }

  function normalizeDoorConfiguration(
    value
  ) {
    var normalized =
      normalizeOptionValue(value)
        .toLowerCase();

    if (
      normalized ===
      'double door'
    ) {
      return 'Double Door';
    }

    if (
      normalized ===
      'single door'
    ) {
      return 'Single Door';
    }

    if (
      normalized ===
      'none'
    ) {
      return 'None';
    }

    return normalizeOptionValue(value);
  }

  function isJambKitSizeOptionName(
    optionName
  ) {
    return /jamb kit size/i.test(
      String(optionName || '')
    );
  }

  function isSubordinateBundledJambKitOptionName(
    optionName
  ) {
    if (!optionName) return false;

    return (
      isJambKitSizeOptionName(
        optionName
      ) ||
      isJambKitFinishSelectorOptionName(
        optionName
      )
    );
  }

  function isBundledJambKitOptionName(
    optionName
  ) {
    if (!optionName) return false;

    return (
      /door prehanging/i.test(
        optionName
      ) ||
      isSubordinateBundledJambKitOptionName(
        optionName
      )
    );
  }

  function shouldExcludeOptionFromLabelExtras(
    optionName,
    response
  ) {
    return isHingeFinishOptionName(
      optionName
    );
  }

  function findOptionValueData(
    opt,
    optionValue
  ) {
    if (
      !opt ||
      !opt.option_values ||
      optionValue == null ||
      optionValue === ''
    ) {
      return null;
    }

    for (
      var i = 0;
      i <
      Object.keys(
        opt.option_values
      ).length;
      i++
    ) {
      var optionValueData =
        opt.option_values[i];

      if (
        optionValuesMatch(
          optionValueData.option_value,
          optionValue
        )
      ) {
        return optionValueData;
      }
    }

    return null;
  }

  function getGildVariantPriceDollars(
    prepared,
    variantId
  ) {
    if (
      !prepared ||
      !prepared.options ||
      variantId == null
    ) {
      return null;
    }

    var targetId =
      String(variantId);

    var optionsLength =
      Object.keys(
        prepared.options
      ).length;

    for (
      var i = 0;
      i < optionsLength;
      i++
    ) {
      var opt =
        prepared.options[i];

      if (!opt || !opt.option_values) {
        continue;
      }

      for (
        var j = 0;
        j <
        Object.keys(
          opt.option_values
        ).length;
        j++
      ) {
        var optionValueData =
          opt.option_values[j];

        if (
          optionValueData &&
          optionValueData.variant_id != null &&
          String(
            optionValueData.variant_id
          ) === targetId &&
          optionValueData.variant_price != null &&
          optionValueData.variant_price !== ''
        ) {
          var parsed =
            parseFloat(
              String(
                optionValueData.variant_price
              ).replace(/,/g, '')
            );

          if (!isNaN(parsed)) {
            return parsed;
          }
        }
      }
    }

    return null;
  }

  function getShopifyVariantPriceDollars(
    variantId
  ) {
    if (variantId == null) {
      return null;
    }

    var cached =
      shopifyVariantPriceCache[
        String(variantId)
      ];

    return cached == null
      ? null
      : cached;
  }

  function cacheShopifyVariantPrice(
    variantId,
    priceCents
  ) {
    if (
      variantId == null ||
      typeof priceCents !== 'number'
    ) {
      return;
    }

    shopifyVariantPriceCache[
      String(variantId)
    ] =
      priceCents / 100;
  }

  function cacheActiveVariantPrice() {
    if (
      lastVariantFromPicker &&
      typeof lastVariantFromPicker.price ===
        'number'
    ) {
      cacheShopifyVariantPrice(
        lastVariantFromPicker.id,
        lastVariantFromPicker.price
      );
    }
  }

  function collectVariantIdsFromOptionsResponse(
    response
  ) {
    var ids = [];
    var seen = {};

    if (
      !response ||
      !response.options
    ) {
      return ids;
    }

    var optionsLength =
      Object.keys(
        response.options
      ).length;

    for (
      var i = 0;
      i < optionsLength;
      i++
    ) {
      var opt =
        response.options[i];

      if (!opt || !opt.option_values) {
        continue;
      }

      for (
        var j = 0;
        j <
        Object.keys(
          opt.option_values
        ).length;
        j++
      ) {
        var optionValue =
          opt.option_values[j];

        if (
          optionValue &&
          optionValue.variant_id != null
        ) {
          var variantId =
            String(
              optionValue.variant_id
            );

          if (!seen[variantId]) {
            seen[variantId] = true;
            ids.push(variantId);
          }
        }
      }
    }

    return ids;
  }

  function loadShopifyVariantPrices(
    variantIds
  ) {
    var uniqueIds = [];
    var seen = {};

    (
      variantIds || []
    ).forEach(function (variantId) {
      var idString =
        String(variantId);

      if (
        !idString ||
        seen[idString]
      ) {
        return;
      }

      seen[idString] = true;

      if (
        Object.prototype.hasOwnProperty.call(
          shopifyVariantPriceCache,
          idString
        )
      ) {
        return;
      }

      uniqueIds.push(idString);
    });

    if (!uniqueIds.length) {
      return $.Deferred()
        .resolve()
        .promise();
    }

    if (shopifyVariantPriceLoadPromise) {
      return shopifyVariantPriceLoadPromise;
    }

    shopifyVariantPriceLoadPromise =
      $.when.apply(
        $,
        uniqueIds.map(function (variantId) {
          return $.ajax({
            url:
              '/variants/' +
              variantId +
              '.js',
            dataType: 'json'
          })
            .done(function (data) {
              if (
                data &&
                typeof data.price ===
                  'number'
              ) {
                cacheShopifyVariantPrice(
                  data.id || variantId,
                  data.price
                );

                return;
              }

              shopifyVariantPriceCache[
                String(variantId)
              ] = 0;
            })
            .fail(function () {
              shopifyVariantPriceCache[
                String(variantId)
              ] = 0;
            });
        })
      ).always(function () {
        shopifyVariantPriceLoadPromise =
          null;
      });

    return shopifyVariantPriceLoadPromise;
  }

  function getCompanionVariantPriceDollars(
    variantId,
    prepared
  ) {
    var shopifyPrice =
      getShopifyVariantPriceDollars(
        variantId
      );

    if (
      shopifyPrice != null &&
      shopifyPrice > 0
    ) {
      return shopifyPrice;
    }

    var gildPrice =
      getGildVariantPriceDollars(
        prepared,
        variantId
      );

    if (
      gildPrice != null &&
      gildPrice > 0
    ) {
      return gildPrice;
    }

    var domPrice =
      getDomPriceForVariantId(
        variantId,
        prepared
      );

    if (
      domPrice != null &&
      domPrice > 0
    ) {
      return domPrice;
    }

    return 0;
  }

  function getDomPriceForVariantId(
    variantId,
    prepared
  ) {
    if (
      variantId == null ||
      !prepared ||
      !prepared.options
    ) {
      return null;
    }

    var targetId =
      String(variantId);

    var optionsLength =
      Object.keys(
        prepared.options
      ).length;

    for (
      var i = 0;
      i < optionsLength;
      i++
    ) {
      var opt =
        prepared.options[i];

      if (!opt || !opt.option_values) {
        continue;
      }

      var $row =
        getConfigurationOptionRow(i);

      if (
        !$row.length ||
        !isConfiguratorOptionVisible(
          $row
        )
      ) {
        continue;
      }

      for (
        var j = 0;
        j <
        Object.keys(
          opt.option_values
        ).length;
        j++
      ) {
        var optionValueData =
          opt.option_values[j];

        if (
          !optionValueData ||
          String(
            optionValueData.variant_id
          ) !== targetId
        ) {
          continue;
        }

        var selectedValue =
          getSelectedOptionValue(i);

        if (
          !optionValuesMatch(
            optionValueData.option_value,
            selectedValue
          )
        ) {
          continue;
        }

        if (
          opt.option_type ===
          'swatches'
        ) {
          var $swatch =
            $row.find(
              '.custom-swatches:checked'
            );

          if ($swatch.length) {
            var domAttrPrice =
              parseFloat(
                $swatch.attr(
                  'data-price'
                )
              );

            if (
              !isNaN(domAttrPrice) &&
              domAttrPrice > 0
            ) {
              return domAttrPrice;
            }

            var swatchExtra =
              getSwatchExtraPrice(
                $swatch
              );

            if (swatchExtra > 0) {
              return swatchExtra;
            }
          }
        }

        if (
          opt.option_type ===
          'dropdown'
        ) {
          var dropdownExtra =
            parseMoneyAmount(
              $row
                .find(
                  '.configuration-option-dropdown option:selected'
                )
                .text()
            );

          if (
            dropdownExtra > 0
          ) {
            return dropdownExtra;
          }
        }

        if (
          optionValueData.variant_price != null &&
          optionValueData.variant_price !== ''
        ) {
          var parsed =
            parseFloat(
              String(
                optionValueData.variant_price
              ).replace(/,/g, '')
            );

          if (
            !isNaN(parsed) &&
            parsed > 0
          ) {
            return parsed;
          }
        }
      }
    }

    return null;
  }

  function collectVisibleProductAddAssoDomTotal() {
    var total = 0;

    $(
      '.configuration-option-each'
    ).each(function () {
      if (
        !isConfiguratorOptionVisible(
          $(this)
        )
      ) {
        return;
      }

      $(
        this
      )
        .find(
          '.product-add-asso:checked'
        )
        .each(function () {
          var domPrice =
            parseFloat(
              $(this).attr(
                'data-price'
              )
            );

          if (
            !isNaN(domPrice) &&
            domPrice > 0
          ) {
            total += domPrice;
          }
        });
    });

    return total;
  }

  function getMainLineQuantityMultiplier(
    doorConfig
  ) {
    if (
      doorConfig ===
      'Double Door'
    ) {
      return 2;
    }

    if (
      doorConfig ===
        'None' &&
      single_door_flag ===
        2
    ) {
      return 2;
    }

    return 1;
  }

  function buildSwatchDisplayLabel(
    optionValue,
    optionValueData,
    optionName
  ) {
    var label =
      optionValue;

    if (
      optionName &&
      isHingeFinishOptionName(optionName)
    ) {
      return stripOptionValuePriceSuffix(label);
    }

    if (
      optionValueData &&
      optionValueData.adjust_price ===
        'Y' &&
      parseIncrementalPrice(
        label
      ) == null &&
      optionValueData.variant_price != null &&
      optionValueData.variant_price !== ''
    ) {
      label +=
        formatOptionPriceLabelSuffix(
          optionValueData.variant_price
        );
    }

    return label;
  }

  function isConfiguratorOptionVisible(
    $optionEl
  ) {
    if (!$optionEl.length) {
      return false;
    }

    if (
      $optionEl.css(
        'display'
      ) === 'none'
    ) {
      return false;
    }

    return $optionEl.is(
      ':visible'
    );
  }

  function getDoorConfiguration() {
    var doorConfigIndex =
      getDoorConfigurationOptionIndex();

    var $row =
      getConfigurationOptionRow(
        doorConfigIndex
      );

    if ($row.length) {
      var $dropdown =
        $row.find(
          '.configuration-option-dropdown'
        );

      if ($dropdown.length) {
        return normalizeDoorConfiguration(
          $dropdown.val() || ''
        );
      }

      return normalizeDoorConfiguration(
        $row
          .find(
            '.custom-swatches:checked'
          )
          .val() || ''
      );
    }

    if ($('#C0').length) {
      return normalizeDoorConfiguration(
        $('#C0').val() || ''
      );
    }

    return normalizeDoorConfiguration(
      $('.main-0 .custom-swatches:checked')
        .val() || ''
    );
  }

  function getOptionDoorScope(
    optionName
  ) {
    var name =
      String(
        optionName || ''
      ).trim();

    if (!name) {
      return 'any';
    }

    var hasSingle =
      /\bsingle\b/i.test(name);

    var hasDouble =
      /\bdouble\b/i.test(name);

    if (
      hasDouble &&
      !hasSingle
    ) {
      return 'double';
    }

    if (hasSingle) {
      return 'single';
    }

    if (
      /^handle preparation$/i.test(
        name
      )
    ) {
      return 'single';
    }

    return 'any';
  }

  function optionAppliesToDoorConfig(
    scope,
    doorConfig
  ) {
    if (scope === 'any') {
      return true;
    }

    if (
      doorConfig ===
      'Single Door'
    ) {
      return scope === 'single';
    }

    if (
      doorConfig ===
      'Double Door'
    ) {
      return scope === 'double';
    }

    return true;
  }

  function isSlabDoorPreparationOption(
    optionName
  ) {
    return /slab door preparation/i.test(
      String(optionName || '')
    );
  }

  function getPrehangOptionIndex(
    response,
    doorConfig
  ) {
    if (
      !response ||
      !response.options
    ) {
      return -1;
    }

    var pattern =
      doorConfig ===
      'Double Door'
        ? /double door prehanging/i
        : /single door prehanging/i;

    var optionsLength =
      Object.keys(
        response.options
      ).length;

    for (
      var i = 0;
      i < optionsLength;
      i++
    ) {
      if (
        pattern.test(
          response.options[i]
            .option_name
        )
      ) {
        return i;
      }
    }

    return -1;
  }

  function getSelectedOptionValue(
    optionIndex
  ) {
    var $row =
      getConfigurationOptionRow(
        optionIndex
      );

    if (!$row.length) {
      return '';
    }

    var swatchValue =
      $row
        .find(
          '.custom-swatches:checked'
        )
        .val();

    if (swatchValue) {
      return String(
        swatchValue
      );
    }

    var dropdownValue =
      $row
        .find(
          '.configuration-option-dropdown'
        )
        .val();

    return dropdownValue
      ? String(dropdownValue)
      : '';
  }

  function isJambKitPrehangSelected(
    response
  ) {
    var doorConfig =
      getDoorConfiguration();

    if (
      doorConfig !== 'Single Door' &&
      doorConfig !== 'Double Door'
    ) {
      return false;
    }

    var options =
      response && response.options
        ? response.options
        : null;

    if (
      !options &&
      currentOptionsResponse &&
      currentOptionsResponse.options
    ) {
      options =
        currentOptionsResponse.options;
    }

    if (!options) return false;

    var prehangIndex =
      getPrehangOptionIndex(
        {
          options: options
        },
        doorConfig
      );

    if (
      prehangIndex === -1
    ) {
      return false;
    }

    var selected =
      getSelectedOptionValue(
        prehangIndex
      );

    if (!selected) {
      return false;
    }

    return (
      /yes,\s*prehang/i.test(
        selected
      ) ||
      /\brapidhang/i.test(
        selected
      )
    );
  }

  function sumCompanionVariantPrices(
    variantIds,
    prepared
  ) {
    var total = 0;

    (
      variantIds || []
    ).forEach(function (variantId) {
      total +=
        getCompanionVariantPriceDollars(
          variantId,
          prepared
        );
    });

    return total;
  }

  function getLabelExtraAmountForCompanionVariant(
    prepared,
    response,
    variantId
  ) {
    if (
      !prepared ||
      !prepared.options ||
      variantId == null
    ) {
      return 0;
    }

    var targetId =
      String(variantId);

    var optionsLength =
      Object.keys(
        prepared.options
      ).length;

    for (
      var ix = 0;
      ix < optionsLength;
      ix++
    ) {
      if (
        prepared.options[ix]
          .option_id ==
        null
      ) {
        continue;
      }

      var opt =
        prepared.options[ix];

      if (
        shouldExcludeOptionFromLabelExtras(
          opt.option_name,
          prepared || response
        )
      ) {
        continue;
      }

      var $optionRow =
        getConfigurationOptionRow(
          ix
        );

      if (
        !isConfiguratorOptionVisible(
          $optionRow
        )
      ) {
        continue;
      }

      if (
        opt.option_type ===
        'swatches'
      ) {
        var $selectedSwatch =
          $optionRow.find(
            '.custom-swatches:checked'
          );

        if (
          !$selectedSwatch.length
        ) {
          continue;
        }

        var swatchData =
          findOptionValueData(
            opt,
            $selectedSwatch.val()
          );

        if (
          swatchData &&
          String(
            swatchData.variant_id
          ) === targetId
        ) {
          return getSwatchExtraPrice(
            $selectedSwatch
          );
        }

        continue;
      }

      if (
        opt.option_type ===
        'dropdown'
      ) {
        var dropdownValue =
          $optionRow
            .find(
              '.configuration-option-dropdown'
            )
            .val() ||
          $('#C' + ix).val() ||
          '';

        if (!dropdownValue) {
          continue;
        }

        var dropdownData =
          findOptionValueData(
            opt,
            dropdownValue
          );

        if (
          dropdownData &&
          String(
            dropdownData.variant_id
          ) === targetId
        ) {
          return parseMoneyAmount(
            $optionRow
              .find(
                '.configuration-option-dropdown option:selected'
              )
              .text()
          );
        }

        continue;
      }

      if (
        opt.option_type ===
        'checkboxes'
      ) {
        var checkboxExtra = 0;

        $optionRow
          .find(
            '.custom-checkboxes:checked'
          )
          .each(function () {
            var checkboxValue =
              $(this).val() || '';

            var checkboxData =
              findOptionValueData(
                opt,
                checkboxValue
              );

            if (
              checkboxData &&
              String(
                checkboxData.variant_id
              ) === targetId
            ) {
              checkboxExtra +=
                parseMoneyAmount(
                  $(this)
                    .next('label')
                    .text()
                );
            }
          });

        if (checkboxExtra > 0) {
          return checkboxExtra;
        }
      }
    }

    return 0;
  }

  function calculateDisplayedConfiguratorTotal(
    response
  ) {
    if (!response) {
      return {
        total: 0,
        compareTotal: 0,
        prepared: null,
        companionVariantIds: [],
        pricingVariantIds: [],
        needsPriceLoad: false
      };
    }

    var doorConfig =
      getDoorConfiguration();

    if (!doorConfig) {
      var fallbackPrices =
        getBaseConfiguratorPrices(
          'Single Door'
        );

      return {
        total:
          fallbackPrices.basePrice,

        compareTotal:
          fallbackPrices.comparePrice,

        prepared:
          prepareCustomResponse(
            response
          ),

        companionVariantIds: [],

        pricingVariantIds: [],

        needsPriceLoad: false
      };
    }

    cacheActiveVariantPrice();

    var prepared =
      prepareCustomResponse(
        response
      );

    var prices =
      getBaseConfiguratorPrices(
        doorConfig
      );

    var extras =
      collectAllConfiguratorExtras(
        response
      );

    var addonTotal =
      extras.extra_value +
      extras.extra_price;

    /*
     * IMPORTANT:
     * Associated products are now read dynamically from DOM.
     */
    var companionVariantIds =
      collectAssociatedVariantIds(
        prepared
      );

    return {
      total:
        prices.basePrice +
        addonTotal,

      compareTotal:
        prices.comparePrice > 0
          ? prices.comparePrice +
            addonTotal
          : prices.basePrice +
            addonTotal,

      prepared: prepared,

      companionVariantIds:
        companionVariantIds,

      pricingVariantIds: [],

      needsPriceLoad: false
    };
  }

  function optionShouldBeVisible(
    optionIndex,
    response
  ) {
    if (
      !response ||
      !response.options ||
      !response.options[
        optionIndex
      ]
    ) {
      return true;
    }

    var optionName =
      response.options[
        optionIndex
      ].option_name;

    if (
      isSlabDoorPreparationOption(
        optionName
      ) &&
      isJambKitPrehangSelected(
        response
      )
    ) {
      return false;
    }

    var scope =
      getOptionDoorScope(
        optionName
      );

    return optionAppliesToDoorConfig(
      scope,
      getDoorConfiguration()
    );
  }

  function findNextRelevantOptionIndex(
    fromIndex,
    response
  ) {
    if (
      !response ||
      !response.options
    ) {
      return -1;
    }

    var optionsLength =
      Object.keys(
        response.options
      ).length;

    for (
      var i = fromIndex;
      i < optionsLength;
      i++
    ) {
      if (
        optionShouldBeVisible(
          i,
          response
        )
      ) {
        return i;
      }
    }

    return -1;
  }

  function revealConfigurationOptionForDoorConfig(
    optionIndex,
    response
  ) {
    if (
      !optionShouldBeVisible(
        optionIndex,
        response
      )
    ) {
      return;
    }

    revealConfigurationOption(
      optionIndex
    );
  }

  function getDoorWidthInches() {
    var widthStr = '';

    if (lastVariantFromPicker) {
      var opts = lastVariantFromPicker.options;
      if (Array.isArray(opts)) {
        for (var i = 0; i < opts.length; i++) {
          var val = String(opts[i] || '').trim();
          if (/\d+/.test(val) && !/single|double/i.test(val)) {
            widthStr = val;
            break;
          }
        }
      }
      if (!widthStr && lastVariantFromPicker.title) {
        var titleMatch = String(lastVariantFromPicker.title).match(/(\d+)\s*(?:"|in|'|x|\s|$)/i);
        if (titleMatch) {
          widthStr = titleMatch[1];
        }
      }
      if (!widthStr && lastVariantFromPicker.option1 && /\d+/.test(lastVariantFromPicker.option1) && !/single|double/i.test(lastVariantFromPicker.option1)) {
        widthStr = lastVariantFromPicker.option1;
      }
      if (!widthStr && lastVariantFromPicker.option2 && /\d+/.test(lastVariantFromPicker.option2) && !/single|double/i.test(lastVariantFromPicker.option2)) {
        widthStr = lastVariantFromPicker.option2;
      }
      if (!widthStr && lastVariantFromPicker.option3 && /\d+/.test(lastVariantFromPicker.option3) && !/single|double/i.test(lastVariantFromPicker.option3)) {
        widthStr = lastVariantFromPicker.option3;
      }
    }

    if (!widthStr) {
      var $wInput = $('.js-product-form-main, variant-picker, form[action*="/cart/add"], .product-form')
        .find('input[name="Width"]:checked, select[name="options[Width]"], input[name="options[Width]"]:checked, select[name="Width"], [data-option-name*="width" i] select, [data-option-name*="width" i] input:checked, select[name*="width" i], input[name*="width" i]:checked')
        .first();

      if ($wInput.length) {
        widthStr = $wInput.val() || '';
      }
    }

    if (!widthStr) {
      var $fallback = $('[name="Width"], [name="options[Width]"], [name="options[Size]"]').first();
      if ($fallback.length) {
        widthStr = $fallback.val() || '';
      }
    }

    if (!widthStr) return null;

    var str = String(widthStr).trim();

    var ftInMatch = str.match(/(\d+)\s*'\s*(\d+)?\s*"?/);
    if (ftInMatch) {
      var ft = parseInt(ftInMatch[1], 10) || 0;
      var inch = parseInt(ftInMatch[2], 10) || 0;
      return ft * 12 + inch;
    }

    var numMatch = str.match(/(\d+(?:\.\d+)?)/);
    if (numMatch) {
      return parseFloat(numMatch[1]);
    }

    return null;
  }

  function getHandlePreparationOptionRows(response) {
    var $rows = $();

    var res = response || currentOptionsResponse;
    if (res && res.options) {
      var optionsLength = Object.keys(res.options).length;
      for (var i = 0; i < optionsLength; i++) {
        var optName = String(res.options[i].option_name || '').trim();
        if (/handle|bore|boring|preparation/i.test(optName) && !/slab door/i.test(optName)) {
          var $r = getConfigurationOptionRow(i);
          if ($r.length) {
            $rows = $rows.add($r);
          }
        }
      }
    }

    if (!$rows.length) {
      $('.configuration-option-each').each(function () {
        var $el = $(this);
        var labelText = $el.find('.configuration-option-level, label, .configuration-option-each__title').text() || '';
        if (/handle\s*prep|double\s*handle|handle\s*boring|preparation/i.test(labelText) && !/slab door/i.test(labelText)) {
          $rows = $rows.add($el);
        }
      });
    }

    return $rows;
  }

  function applyDoubleHandlePreparationRules(response) {
    var $rows = getHandlePreparationOptionRows(response);
    if (!$rows.length) return;

    var doorConfig = getDoorConfiguration();
    var doorWidth = getDoorWidthInches();

    var isRestricted = (doorWidth != null && doorWidth <= 16);

    $rows.each(function () {
      var $row = $(this);
      var $dropdown = $row.find('.configuration-option-dropdown');
      var $swatches = $row.find('.custom-swatches');

      if (!isRestricted) {
        if ($dropdown.length) {
          var $allOptions = $dropdown.data('all-options');
          if ($allOptions && $allOptions.length) {
            var selectedVal = $dropdown.val();
            $dropdown.empty().append($allOptions.clone(true));
            if (selectedVal) $dropdown.val(selectedVal);
          }
          $dropdown.find('option').prop('disabled', false).show();
        }
        if ($swatches.length) {
          $swatches.each(function () {
            $(this).prop('disabled', false);
            $(this).closest('.box, .configuration-swatch-card').show();
          });
        }
        return;
      }

      var isSingleDoor = (doorConfig === 'Single Door');
      var isDoubleDoor = (doorConfig === 'Double Door');

      function matchesAllowed(val) {
        var normalized = normalizeOptionValue(val).trim();
        if (isSingleDoor) {
          return /^not bore$/i.test(normalized) || /not bore/i.test(normalized) || /not boring/i.test(normalized);
        }
        if (isDoubleDoor) {
          if (/left ball catch \(no boring\)\s*\|\s*right ball catch \(no boring\)/i.test(normalized)) {
            return true;
          }
        }
        return false;
      }

      if ($dropdown.length) {
        if (!$dropdown.data('all-options')) {
          $dropdown.data('all-options', $dropdown.find('option').clone(true));
        }
        var $allOptions = $dropdown.data('all-options');

        var currentVal = $dropdown.val() || '';
        var $filteredOptions = $();

        $allOptions.each(function () {
          var optVal = $(this).val();
          if (!optVal) {
            $filteredOptions = $filteredOptions.add($(this).clone(true));
            return;
          }
          if (matchesAllowed(optVal)) {
            $filteredOptions = $filteredOptions.add($(this).clone(true));
          }
        });

        if ($filteredOptions.length) {
          $dropdown.empty().append($filteredOptions);
          var newVal = matchesAllowed(currentVal) ? currentVal : '';
          gildSwatchSuppressChange = true;
          $dropdown.val(newVal);
          if (newVal) {
            $dropdown.attr('aria-selected', 'true');
          } else {
            $dropdown.attr('aria-selected', 'false');
          }
          gildSwatchSuppressChange = false;
        }
      }

      if ($swatches.length) {
        var checkedVal = $row.find('.custom-swatches:checked').val() || '';

        $swatches.each(function () {
          var $sw = $(this);
          var swVal = $sw.val();
          var $card = $sw.closest('.box, .configuration-swatch-card');

          if (matchesAllowed(swVal)) {
            $sw.prop('disabled', false);
            $card.show();
          } else {
            $sw.prop('disabled', true);
            if ($sw.is(':checked')) {
              $sw.prop('checked', false);
            }
            $card.hide();
          }
        });
      }
    });

    setTimeout(function () {
      recalculateConfiguratorPrices();
      updateAddToCartButtonState();
    }, 0);
  }

  function enforceDoorConfigOptionVisibility(
    response
  ) {
    if (
      !response ||
      !response.options
    ) {
      return;
    }

    var doorConfig =
      getDoorConfiguration();

    if (
      doorConfig !==
        'Single Door' &&
      doorConfig !==
        'Double Door'
    ) {
      return;
    }

    var optionsLength =
      Object.keys(
        response.options
      ).length;

    for (
      var i = 0;
      i < optionsLength;
      i++
    ) {
      var $row =
        getConfigurationOptionRow(
          i
        );

      if (
        $row.css('display') !==
        'block'
      ) {
        continue;
      }

      if (
        !optionShouldBeVisible(
          i,
          response
        )
      ) {
        hideConfigurationOption(
          i
        );
      }
    }

    applyDoubleHandlePreparationRules(response);
  }

  function collectDropdownExtras(
    skipDoorConfig,
    response
  ) {
    var extra = 0;

    $('.configuration-option-dropdown').each(
      function () {
        var selectedID =
          $(this).attr('id');

        if (
          skipDoorConfig &&
          selectedID ===
            doorConfigurationSelectId()
        ) {
          return;
        }

        var $optionRow =
          $(this).closest(
            '.configuration-option-each'
          );

        if (
          !isConfiguratorOptionVisible(
            $optionRow
          )
        ) {
          return;
        }

        var optionName =
          $optionRow
            .find(
              '.configuration-option-title-text'
            )
            .text();

        if (
          shouldExcludeOptionFromLabelExtras(
            optionName,
            response
          )
        ) {
          return;
        }

        var selectedText =
          $('#' + selectedID)
            .find(':selected')
            .text();

        var incremental =
          parseIncrementalPrice(
            selectedText
          );

        extra +=
          incremental != null
            ? incremental
            : parseMoneyAmount(
                selectedText
              );
      }
    );

    return extra;
  }

  function collectCheckboxExtras(response) {
    var extra = 0;

    $('.custom-checkboxes').each(
      function () {
        if (!this.checked) {
          return;
        }

        var $optionRow =
          $(this).closest(
            '.configuration-option-each'
          );

        if (
          !isConfiguratorOptionVisible(
            $optionRow
          )
        ) {
          return;
        }

        var optionName =
          $optionRow
            .find(
              '.configuration-option-title-text'
            )
            .text();

        if (
          shouldExcludeOptionFromLabelExtras(
            optionName,
            response
          )
        ) {
          return;
        }

        var labelText =
          $(this)
            .next('label')
            .text();

        var incremental =
          parseIncrementalPrice(
            labelText
          );

        extra +=
          incremental != null
            ? incremental
            : parseMoneyAmount(
                labelText
              );
      }
    );

    return extra;
  }

  function parseIncrementalPrice(text) {
    if (
      text == null ||
      text === ''
    ) {
      return null;
    }

    var match =
      String(text).match(
        /\[\+\s*\$?\s*([\d,.]+)/i
      );

    if (!match) {
      return null;
    }

    var parsed =
      parseFloat(
        String(
          match[1]
        ).replace(/,/g, '')
      );

    return isNaN(parsed)
      ? null
      : parsed;
  }

  function getSwatchLabelText($swatch) {
    return (
      $swatch
        .siblings(
          'label.custom-swatches-label'
        )
        .text() ||
      $swatch
        .closest('.tex-box')
        .find(
          'label.custom-swatches-label'
        )
        .text() ||
      ''
    ).trim();
  }

  function getSwatchExtraPrice($swatch) {
    var labelText =
      getSwatchLabelText(
        $swatch
      );

    var valueText =
      $swatch.val() || '';

    var incremental =
      parseIncrementalPrice(
        labelText
      );

    if (
      incremental == null
    ) {
      incremental =
        parseIncrementalPrice(
          valueText
        );
    }

    if (
      incremental != null
    ) {
      return incremental;
    }

    if (
      $swatch.hasClass(
        'product-add-asso'
      )
    ) {
      return parseMoneyAmount(
        $swatch.attr(
          'data-price'
        )
      );
    }

    return (
      parseMoneyAmount(
        labelText
      ) ||
      parseMoneyAmount(
        valueText
      )
    );
  }

  /*function collectSwatchExtras(response) {
    var extra = 0;

    $('.configuration-option-each').each(
      function () {
        var $option =
          $(this);

        if (
          !isConfiguratorOptionVisible(
            $option
          ) ||
          $option.hasClass(
            'main-' +
              getDoorConfigurationOptionIndex()
          )
        ) {
          return;
        }

        var optionName =
          $option
            .find(
              '.configuration-option-title-text'
            )
            .text();

        if (
          shouldExcludeOptionFromLabelExtras(
            optionName,
            response
          )
        ) {
          return;
        }

        $option
          .find(
            '.custom-swatches:checked'
          )
          .each(function () {
            extra +=
              getSwatchExtraPrice(
                $(this)
              );
          });
      }
    );

    return extra;
  }*/


  function collectSwatchExtras(response) {
    var extra = 0;

    $('.product-add-asso.custom-swatches:checked').each(function () {

        var rawPrice = $(this).attr('data-price') || '';

        var price = parseFloat(
            rawPrice
                .replace(/[^0-9.-]+/g, '')
                .replace(/,/g, '')
        );

        if (!isNaN(price)) {
            extra += price;
        }
    });

    return extra;
}

  /* ============================================================
   * ASSOCIATED PRODUCT FUNCTIONS
   * ============================================================ */

  function normalizeCartVariantId(
    variantId
  ) {
    var parsed =
      parseInt(
        String(variantId),
        10
      );

    return isNaN(parsed) ||
      parsed <= 0
      ? null
      : parsed;
  }

  function findAssociatedVariantIdForOptionValue(
    opt,
    optionValue,
    $selectedElement
  ) {
    /*
     * DOM data-variant-id has priority.
     */
    if (
      $selectedElement &&
      $selectedElement.length
    ) {
      var domVariantId =
        $selectedElement.attr(
          'data-variant-id'
        );

      if (
        domVariantId != null &&
        String(
          domVariantId
        ).trim() !== ''
      ) {
        return String(
          domVariantId
        );
      }
    }

    var optionValueData =
      findOptionValueData(
        opt,
        optionValue
      );

    if (
      optionValueData &&
      optionValueData.variant_id != null
    ) {
      return String(
        optionValueData.variant_id
      );
    }

    return null;
  }

  function findSelectedVariantIdForOption(
    opt,
    optionIndex
  ) {
    var $optionRow =
      getConfigurationOptionRow(
        optionIndex
      );

    if (
      !$optionRow.length ||
      !isConfiguratorOptionVisible(
        $optionRow
      )
    ) {
      return null;
    }

    if (
      opt.option_type ===
      'swatches'
    ) {
      var $selectedSwatch =
        $optionRow.find(
          '.custom-swatches:checked'
        );

      if (
        !$selectedSwatch.length
      ) {
        return null;
      }

      return findAssociatedVariantIdForOptionValue(
        opt,
        $selectedSwatch.val(),
        $selectedSwatch
      );
    }

    if (
      opt.option_type ===
      'dropdown'
    ) {
      var $selectedOption =
        $optionRow.find(
          '.configuration-option-dropdown option:selected[data-variant-id]'
        );

      if (
        $selectedOption.length
      ) {
        return findAssociatedVariantIdForOptionValue(
          opt,
          $selectedOption.val(),
          $selectedOption
        );
      }

      var dropdownValue =
        $optionRow
          .find(
            '.configuration-option-dropdown'
          )
          .val() ||
        $('#C' + optionIndex).val() ||
        '';

      if (!dropdownValue) {
        return null;
      }

      return findAssociatedVariantIdForOptionValue(
        opt,
        dropdownValue
      );
    }

    if (
      opt.option_type ===
      'checkboxes'
    ) {
      var checkboxVariantId =
        null;

      $optionRow
        .find(
          '.custom-checkboxes:checked'
        )
        .each(function () {
          if (checkboxVariantId) {
            return;
          }

          checkboxVariantId =
            findAssociatedVariantIdForOptionValue(
              opt,
              $(this).val(),
              $(this)
            );
        });

      return checkboxVariantId;
    }

    return null;
  }

  function findJambKitCompanionVariantId(
    custom_response
  ) {
    if (
      !custom_response ||
      !custom_response.options
    ) {
      return null;
    }

    if (
      !isJambKitPrehangSelected(
        custom_response
      )
    ) {
      return null;
    }

    var total_options =
      Object.keys(
        custom_response.options
      ).length;

    var optionMatchers = [
      function (name) {
        return /door prehanging/i.test(
          name
        );
      },

      isJambKitSizeOptionName
    ];

    for (
      var m = 0;
      m < optionMatchers.length;
      m++
    ) {
      for (
        var ix = 0;
        ix < total_options;
        ix++
      ) {
        var opt =
          custom_response.options[
            ix
          ];

        if (
          !opt ||
          !optionMatchers[m](
            opt.option_name
          )
        ) {
          continue;
        }

        var variantId =
          findSelectedVariantIdForOption(
            opt,
            ix
          );

        if (variantId) {
          return variantId;
        }
      }
    }

    return findJambKitCompanionVariantIdFromDom();
  }

  function shouldSkipCompanionOptionByName(
    optionName,
    custom_response
  ) {
    if (
      isHingeFinishOptionName(
        optionName
      )
    ) {
      return true;
    }

    if (
      isJambKitFinishSelectorOptionName(
        optionName
      )
    ) {
      return true;
    }

    if (
      !isJambKitPrehangSelected(
        custom_response
      )
    ) {
      return false;
    }

    if (
      /door prehanging/i.test(
        optionName
      )
    ) {
      return true;
    }

    if (
      isJambKitSizeOptionName(
        optionName
      )
    ) {
      return true;
    }

    return false;
  }

  function findJambKitCompanionVariantIdFromDom() {
    var optionMatchers = [
      /door prehanging/i,
      /jamb kit size/i
    ];

    var found = null;

    $('.configuration-option-each').each(
      function () {
        if (found) return false;

        var $row =
          $(this);

        if (
          !isConfiguratorOptionVisible(
            $row
          )
        ) {
          return;
        }

        var optionName =
          $row
            .find(
              '.configuration-option-title-text'
            )
            .text()
            .trim();

        for (
          var m = 0;
          m < optionMatchers.length;
          m++
        ) {
          if (
            !optionMatchers[m].test(
              optionName
            )
          ) {
            continue;
          }

          var $linkedInput =
            $row.find(
              '.custom-swatches:checked[data-variant-id], .custom-checkboxes:checked[data-variant-id]'
            );

          if (
            $linkedInput.length &&
            $linkedInput.attr(
              'data-variant-id'
            )
          ) {
            found =
              $linkedInput.attr(
                'data-variant-id'
              );

            return false;
          }

          break;
        }
      }
    );

    return found;
  }

  /*
   * THIS IS THE IMPORTANT DYNAMIC FUNCTION.
   *
   * It reads the selected associated products directly
   * from the DOM.
   *
   * Supported:
   *
   * 1. Radio / checkbox:
   *    .product-add-asso:checked[data-variant-id]
   *
   * 2. Dropdown option:
   *    option.product-add-asso:selected[data-variant-id]
   */
  
  function getSelectedAssociatedVariantIds() {
    var variantIds = [];
    var seen = {};

    function pushVariant(rawVariantId, element) {
      var normalizedId =
        normalizeCartVariantId(
          rawVariantId
        );

      if (
        !normalizedId ||
        seen[normalizedId]
      ) {
        return;
      }

      seen[normalizedId] = true;

      variantIds.push(
        normalizedId
      );

      console.log(
        '=== ASSOCIATED PRODUCT FOUND ===',
        {
          variantId:
            normalizedId,

          value:
            $(element).val(),

          element:
            element
        }
      );
    }

    /*
     * RADIO / CHECKBOX ASSOCIATED PRODUCTS
     */
    $('#api-response')
      .find(
        '.product-add-asso:checked[data-variant-id]'
      )
      .each(function () {
        pushVariant(
          $(this).attr(
            'data-variant-id'
          ),
          this
        );
      });

    /*
     * DROPDOWN ASSOCIATED PRODUCTS
     */
    $('#api-response')
      .find(
        'select option.product-add-asso:selected[data-variant-id]'
      )
      .each(function () {
        pushVariant(
          $(this).attr(
            'data-variant-id'
          ),
          this
        );
      });

    console.log(
      '=== FINAL DYNAMIC ASSOCIATED VARIANT IDS ===',
      variantIds
    );

    return variantIds;
  }

  /*
   * Keep the original function name so all existing parts
   * of your configurator continue to work.
   */
  function collectAssociatedVariantIds(
    custom_response
  ) {
    return getSelectedAssociatedVariantIds();
  }

  function collectDomAssociatedVariantIds(
    custom_response
  ) {
    /*
     * Same dynamic DOM source.
     */
    return getSelectedAssociatedVariantIds();
  }

  function collectLabelExtrasWithoutVariantCharge(
    prepared,
    companionVariantIds
  ) {
    if (
      !prepared ||
      !prepared.options
    ) {
      return 0;
    }

    var chargedVariantIds = {};

    (
      companionVariantIds || []
    ).forEach(function (variantId) {
      chargedVariantIds[
        String(variantId)
      ] = true;
    });

    var extra = 0;

    var optionsLength =
      Object.keys(
        prepared.options
      ).length;

    for (
      var ix = 0;
      ix < optionsLength;
      ix++
    ) {
      if (
        prepared.options[ix]
          .option_id == null
      ) {
        continue;
      }

      var opt =
        prepared.options[ix];

      var optionName =
        opt.option_name;

      if (
        shouldExcludeOptionFromLabelExtras(
          optionName,
          prepared
        )
      ) {
        continue;
      }

      var $optionRow =
        getConfigurationOptionRow(
          ix
        );

      if (
        !isConfiguratorOptionVisible(
          $optionRow
        )
      ) {
        continue;
      }

      var selectedValue =
        '';

      if (
        opt.option_type ===
        'dropdown'
      ) {
        selectedValue =
          $optionRow
            .find(
              '.configuration-option-dropdown'
            )
            .val() ||
          $('#C' + ix).val() ||
          '';

        if (!selectedValue) {
          continue;
        }

        var dropdownData =
          findOptionValueData(
            opt,
            selectedValue
          );

        if (
          dropdownData &&
          dropdownData.variant_id != null
        ) {
          if (
            chargedVariantIds[
              String(
                dropdownData.variant_id
              )
            ]
          ) {
            continue;
          }

          if (
            optionAdjustsPrice(
              dropdownData
            )
          ) {
            continue;
          }
        }

        extra += parseMoneyAmount(
          $optionRow
            .find(
              '.configuration-option-dropdown option:selected'
            )
            .text()
        );

        continue;
      }

      if (
        opt.option_type ===
        'swatches'
      ) {
        var $selectedSwatch =
          $optionRow.find(
            '.custom-swatches:checked'
          );

        if (
          !$selectedSwatch.length
        ) {
          continue;
        }

        selectedValue =
          $selectedSwatch.val() || '';

        var swatchData =
          findOptionValueData(
            opt,
            selectedValue
          );

        if (
          swatchData &&
          swatchData.variant_id != null
        ) {
          if (
            chargedVariantIds[
              String(
                swatchData.variant_id
              )
            ]
          ) {
            continue;
          }

          if (
            optionAdjustsPrice(
              swatchData
            )
          ) {
            continue;
          }
        }

        extra +=
          getSwatchExtraPrice(
            $selectedSwatch
          );

        continue;
      }

      if (
        opt.option_type ===
        'checkboxes'
      ) {
        $optionRow
          .find(
            '.custom-checkboxes:checked'
          )
          .each(function () {
            var checkboxValue =
              $(this).val() || '';

            var checkboxData =
              findOptionValueData(
                opt,
                checkboxValue
              );

            if (
              checkboxData &&
              checkboxData.variant_id != null
            ) {
              if (
                chargedVariantIds[
                  String(
                    checkboxData.variant_id
                  )
                ]
              ) {
                return;
              }

              if (
                optionAdjustsPrice(
                  checkboxData
                )
              ) {
                return;
              }
            }

            extra += parseMoneyAmount(
              $(this)
                .next('label')
                .text()
            );
          });
      }
    }

    return extra;
  }

  function getUnchargedConfiguredOptions(
    prepared,
    companionVariantIds
  ) {
    var missing = [];

    if (
      !prepared ||
      !prepared.options
    ) {
      return missing;
    }

    var chargedVariantIds = {};

    (
      companionVariantIds || []
    ).forEach(function (variantId) {
      chargedVariantIds[
        String(variantId)
      ] = true;
    });

    var optionsLength =
      Object.keys(
        prepared.options
      ).length;

    for (
      var ix = 0;
      ix < optionsLength;
      ix++
    ) {
      if (
        prepared.options[ix]
          .option_id == null
      ) {
        continue;
      }

      var opt =
        prepared.options[ix];

      if (
        shouldExcludeOptionFromLabelExtras(
          opt.option_name,
          prepared
        )
      ) {
        continue;
      }

      var $optionRow =
        getConfigurationOptionRow(
          ix
        );

      if (
        !isConfiguratorOptionVisible(
          $optionRow
        )
      ) {
        continue;
      }

      var selectedValue =
        '';

      if (
        opt.option_type ===
        'dropdown'
      ) {
        selectedValue =
          $optionRow
            .find(
              '.configuration-option-dropdown'
            )
            .val() ||
          $('#C' + ix).val() ||
          '';
      } else if (
        opt.option_type ===
        'swatches'
      ) {
        selectedValue =
          $optionRow
            .find(
              '.custom-swatches:checked'
            )
            .val() ||
          '';
      } else {
        continue;
      }

      if (!selectedValue) {
        continue;
      }

      var incremental =
        parseIncrementalPrice(
          selectedValue
        ) ||
        parseIncrementalPrice(
          getSwatchLabelText(
            $optionRow.find(
              '.custom-swatches:checked'
            )
          )
        );

      if (
        incremental == null ||
        incremental <= 0
      ) {
        continue;
      }

      var optionValueData =
        findOptionValueData(
          opt,
          selectedValue
        );

      if (
        optionValueData &&
        optionValueData.variant_id != null
      ) {
        if (
          chargedVariantIds[
            String(
              optionValueData.variant_id
            )
          ]
        ) {
          continue;
        }

        if (
          optionAdjustsPrice(
            optionValueData
          )
        ) {
          continue;
        }
      }

      missing.push({
        option:
          opt.option_name,

        value:
          selectedValue,

        amount:
          incremental
      });
    }

    return missing;
  }

  function calculateChargeableTotal(
    response
  ) {
    cacheActiveVariantPrice();

    var displayed =
      calculateDisplayedConfiguratorTotal(
        response
      );

    return {
      total:
        displayed.total,

      compareTotal:
        displayed.compareTotal,

      prepared:
        displayed.prepared,

      companionVariantIds:
        displayed.companionVariantIds
    };
  }

  /* ============================================================
   * PRICE DISPLAY
   * ============================================================ */

  function refreshDisplayedConfiguratorPrices() {
    if (!currentOptionsResponse) {
      return;
    }

    var doorConfig =
      getDoorConfiguration();

    if (
      doorConfig ===
      'Single Door'
    ) {
      single_door_flag = 1;
    }

    if (
      doorConfig ===
      'Double Door'
    ) {
      single_door_flag = 2;
    }

    if (!doorConfig) {
      resetDisplayedPricesToBase();

      return;
    }

    var result =
      calculateDisplayedConfiguratorTotal(
        currentOptionsResponse
      );

    tot =
      result.total.toFixed(2);

    totc =
      result.compareTotal.toFixed(2);

    updateDisplayedPrices(
      tot,
      totc
    );

    if (result.needsPriceLoad) {
      loadShopifyVariantPrices(
        result.pricingVariantIds
      ).always(function () {
        if (!currentOptionsResponse) {
          return;
        }

        refreshDisplayedConfiguratorPrices();
      });
    }
  }

  function refreshCheckoutAlignedPrices() {
    refreshDisplayedConfiguratorPrices();
  }

  function getConfiguredCartTotal() {
    return parseMoneyAmount(
      $('#productPrice').text()
    );
  }

  function buildGildLineItemPricingProperties(
    configuredTotal
  ) {
    var compareTotal =
      parseMoneyAmount(
        $('#product-extrac').val()
      );

    var basePriceVal =
      $('#product-or-pr').val();

    if (!basePriceVal) {
      basePriceVal =
        formatMoneyAmount(
          unitBasePrice
        );
    }

    return {
      'product-extra':
        formatMoneyAmount(
          configuredTotal
        ),

      'product-extrac':
        compareTotal > 0
          ? $('#product-extrac').val() ||
            formatMoneyAmount(
              compareTotal
            )
          : formatMoneyAmount(
              0
            ),

      'product-or-pr':
        basePriceVal
    };
  }

  function collectAllConfiguratorExtras(response) {
    return {
      extra_value: collectDropdownExtras(true, response) + collectSwatchExtras(response),
      extra_price: collectCheckboxExtras(response),
    };
  }

  function getBaseConfiguratorPrices(
    doorConfig
  ) {
    var basePrice =
      unitBasePrice > 0
        ? unitBasePrice
        : parseMoneyAmount(
            $('#product-or-pr').val()
          );

    var comparePrice =
      hasOriginalComparePrice
        ? unitComparePrice > 0
          ? unitComparePrice
          : parseMoneyAmount(
              $('#productPriceCompareCustom').val()
            )
        : 0;

    var multiplier =
      getMainLineQuantityMultiplier(
        doorConfig
      );

    return {
      basePrice:
        basePrice * multiplier,

      comparePrice:
        comparePrice * multiplier
    };
  }

  function storeUnitPrices(
    baseAmount,
    compareAmount
  ) {
    unitBasePrice =
      baseAmount;

    unitComparePrice =
      compareAmount > 0
        ? compareAmount
        : 0;

    hasOriginalComparePrice =
      unitComparePrice > 0;

    main_pr =
      formatMoneyAmount(
        unitBasePrice
      );

    $('#product-or-pr').val(
      main_pr
    );

    productPriceCompareCustom =
      hasOriginalComparePrice
        ? formatMoneyAmount(
            unitComparePrice
          )
        : '';

    $(
      '#productPriceCompareCustom'
    ).val(
      productPriceCompareCustom
    );
  }

  function captureUnitPricesFromVariant(
    variant
  ) {
    if (
      variant &&
      typeof variant.price ===
        'number'
    ) {
      storeUnitPrices(
        variant.price / 100,
        0
      );

      cacheShopifyVariantPrice(
        variant.id,
        variant.price
      );

      if (
        typeof variant.compare_at_price ===
          'number' &&
        variant.compare_at_price >
          variant.price
      ) {
        storeUnitPrices(
          variant.price / 100,
          variant.compare_at_price /
            100
        );
      }

      if (
        hasGildConfiguration &&
        currentOptionsResponse
      ) {
        refreshDisplayedConfiguratorPrices();
      }

      return;
    }

    captureUnitPricesFromDomFallback();
  }

  function captureUnitPricesFromDomFallback() {
    if (
      hasGildConfiguration &&
      getDoorConfiguration()
    ) {
      return;
    }

    var baseAmount =
      parseMoneyAmount(
        $('#productPrice').text()
      );

    var compareAmount =
      parseMoneyAmount(
        $('#productPriceCompare').text()
      );

    storeUnitPrices(
      baseAmount,
      compareAmount
    );
  }

  function recalculateConfiguratorPrices() {
    if (
      !hasGildConfiguration ||
      !currentOptionsResponse
    ) {
      return;
    }

    refreshDisplayedConfiguratorPrices();
  }

  function updateDisplayedPrices(
    tot,
    totc
  ) {
    var formattedTotal =
      formatMoneyAmount(tot);

    var $priceEl =
      $('#productPrice');

    $('#product-extra').val(
      formattedTotal
    );

    if (!$priceEl.length) {
      return;
    }

    $priceEl.text(
      formattedTotal
    );

    var $priceRoot =
      $priceEl.closest('.price');

    var $compareEl =
      $('#productPriceCompare');

    var $compareWrap =
      $compareEl.closest('.price__was');

    if (
      hasOriginalComparePrice
    ) {
      $('#product-extrac').val(
        formatMoneyAmount(totc)
      );

      $compareEl.text(
        formatMoneyAmount(totc)
      );

      $compareWrap.show();

      $priceRoot.addClass(
        'price--on-sale'
      );

      return;
    }

    $('#product-extrac').val(0);

    $compareEl.text('');

    $compareWrap.hide();

    $priceRoot.removeClass(
      'price--on-sale'
    );
  }

  function resetDisplayedPricesToBase(
    doorConfig
  ) {
    var config =
      doorConfig ||
      getDoorConfiguration() ||
      'Single Door';

    var prices =
      getBaseConfiguratorPrices(
        config
      );

    $('#product-extra').val(0);

    $('#productPrice').text(
      formatMoneyAmount(
        prices.basePrice
      )
    );

    $('#product-extrac').val(0);

    var $priceRoot =
      $('#productPrice').closest('.price');

    var $compareEl =
      $('#productPriceCompare');

    var $compareWrap =
      $compareEl.closest('.price__was');

    if (
      hasOriginalComparePrice
    ) {
      $compareEl.text(
        formatMoneyAmount(
          prices.comparePrice
        )
      );

      $compareWrap.show();

      $priceRoot.addClass(
        'price--on-sale'
      );

      return;
    }

    $compareEl.text('');

    $compareWrap.hide();

    $priceRoot.removeClass(
      'price--on-sale'
    );
  }

  /* ============================================================
   * CONFIGURATION DATA
   * ============================================================ */

  function optionFieldKey(
    optionName,
    optionIndex
  ) {
    return (
      String(optionName)
        .replace(/\s+/g, '-')
        .replace(
          /[^a-z0-9-]/gi,
          '-'
        )
        .replace(
          /-+/g,
          '-'
        )
        .replace(
          /^-|-$/g,
          ''
        )
        .toLowerCase() +
      '-' +
      optionIndex
    );
  }

  function getConfigurationOptionRow(
    optionIndex
  ) {
    return $(
      '.configuration-option-each.main-' +
        optionIndex
    );
  }

  function getOptionIndexFromElement(
    $el
  ) {
    var $row =
      $el.closest(
        '.configuration-option-each'
      );

    if (!$row.length) {
      return NaN;
    }

    var match =
      ($row.attr('class') || '')
        .match(
          /\bmain-(\d+)\b/
        );

    return match
      ? parseInt(
          match[1],
          10
        )
      : NaN;
  }

  function getOptionValueRules(
    option,
    selectedValue
  ) {
    if (
      !option ||
      !option.option_values ||
      selectedValue == null ||
      selectedValue === ''
    ) {
      return null;
    }

    for (
      var i = 0;
      i <
      Object.keys(
        option.option_values
      ).length;
      i++
    ) {
      if (
        option.option_values[i]
          .option_value ===
        selectedValue
      ) {
        return option.option_values[i]
          .rule;
      }
    }

    return null;
  }

  function hideConfigurationOption(
    optionIndex
  ) {
    var $row =
      getConfigurationOptionRow(
        optionIndex
      );

    if (!$row.length) return;

    $row.css(
      'display',
      'none'
    );

    $row.find(
      '.custom-swatches:checked'
    ).prop(
      'checked',
      false
    );

    $row
      .find(
        '.configuration-option-dropdown'
      )
      .each(function () {
        this.selectedIndex = 0;

        $(this).attr(
          'aria-selected',
          'false'
        );
      });

    $row.find(
      '.custom-checkboxes:checked'
    ).prop(
      'checked',
      false
    );

    $row.find(
      '.custom-shorttext'
    ).val('');

    setRowCollapsed(
      $row,
      false
    );

    $row
      .find(
        '.configuration-option-each__choice'
      )
      .text('');
  }

  function revealConfigurationOption(
    optionIndex
  ) {
    var $row =
      getConfigurationOptionRow(
        optionIndex
      );

    if (!$row.length) return;

    $row.css(
      'display',
      'block'
    );

    setRowCollapsed(
      $row,
      false
    );
  }

  function applyOptionVisibilityRules(
    rules,
    response
  ) {
    if (
      !rules ||
      Object.keys(rules).length === 0
    ) {
      return false;
    }

    var visibilityChanged =
      false;

    for (
      var r = 0;
      r <
      Object.keys(rules).length;
      r++
    ) {
      if (
        rules[r].action_type ===
        'S'
      ) {
        var showIndex =
          main_div_arr.indexOf(
            rules[r].option_id
          );

        if (
          showIndex !== -1
        ) {
          revealConfigurationOptionForDoorConfig(
            showIndex,
            response
          );

          if (
            getConfigurationOptionRow(
              showIndex
            ).css(
              'display'
            ) ===
            'block'
          ) {
            visibilityChanged =
              true;
          }
        }
      }

      if (
        rules[r].action_type ===
        'H'
      ) {
        var hideIndex =
          main_div_arr.indexOf(
            rules[r].option_id
          );

        if (
          hideIndex !== -1
        ) {
          hideConfigurationOption(
            hideIndex
          );

          visibilityChanged =
            true;
        }
      }
    }

    return visibilityChanged;
  }

  function getOptionIndexFromFieldKey(
    fieldKey
  ) {
    var match =
      String(fieldKey).match(
        /-(\d+)$/
      );

    return match
      ? match[1]
      : String(
          fieldKey
        ).slice(-1);
  }

  function ensureGildSubmitButtonState() {
    if (!hasGildConfiguration) {
      return;
    }

    var btn =
      getMainAddToCartButton();

    if (!btn) {
      return;
    }

    btn.setAttribute(
      'data-gild-configurator-submit',
      ''
    );

    btn.removeAttribute(
      'data-gild-configurator-pending'
    );
  }

  function setAddToCartPendingState(
    pending
  ) {
    var btn =
      getMainAddToCartButton();

    if (
      !btn ||
      hasGildConfiguration
    ) {
      return;
    }

    if (pending) {
      btn.setAttribute(
        'data-gild-configurator-pending',
        'true'
      );

      btn.disabled = true;

      btn.textContent =
        btn.dataset.preselectionText ||
        'Make a selection';

      return;
    }

    btn.removeAttribute(
      'data-gild-configurator-pending'
    );
  }

  function showConfiguratorError(
    message
  ) {
    var form =
      document.querySelector(
        '.js-product-form-main'
      );

    var errorEl =
      form &&
      form.querySelector(
        '.js-form-error'
      );

    if (!errorEl) {
      return;
    }

    if (!message) {
      errorEl.hidden = true;
      errorEl.textContent = '';
      return;
    }

    errorEl.hidden = false;
    errorEl.textContent =
      message;
  }

  function setConfiguratorSubmitLoading(
    isLoading
  ) {
    var btn =
      getMainAddToCartButton();

    if (!btn) return;

    if (isLoading) {
      btn.setAttribute(
        'aria-disabled',
        'true'
      );

      btn.classList.add(
        'is-loading'
      );

      btn.disabled = true;

      return;
    }

    btn.removeAttribute(
      'aria-disabled'
    );

    btn.classList.remove(
      'is-loading'
    );

    updateAddToCartButtonState();
  }

  function configInputId(
    optionIndex,
    valueIndex
  ) {
    return (
      'config-option-' +
      optionIndex +
      '-' +
      valueIndex
    );
  }

  /* ============================================================
   * BUILD OPTIONS MARKUP
   * ============================================================ */

  function buildOptionsMarkup(
    response
  ) {
    var shop_currency =
      shopCurrency();

    main_div_arr = [];

    doorConfigurationOptionIndex =
      resolveDoorConfigurationOptionIndex(
        response
      );

    $('#api-response').empty();

    var optionsCount =
      Object.keys(
        response.options
      ).length;

    var hasRequiredOptions =
      false;

    for (
      var k = 0;
      k < optionsCount;
      k++
    ) {
      if (
        response.options[k]
          .is_required ===
        'Y'
      ) {
        hasRequiredOptions =
          true;

        break;
      }
    }

    var $optionsContainer =
      $('#api-response');

    if (
      hasRequiredOptions
    ) {
      var legendText =
        $('#api-response').attr(
          'data-required-field-legend'
        ) ||
        '* indicates a required field';

      $optionsContainer =
        $(
          '<fieldset class="configuration-options-fieldset">' +
            '<legend class="configuration-required-legend">' +
            escHtml(
              legendText
            ) +
            '</legend>' +
            '</fieldset>'
        );

      $('#api-response').append(
        $optionsContainer
      );
    }

    for (
      var j = 0;
      j < optionsCount;
      j++
    ) {
      var opt =
        response.options[j];

      if (!opt) continue;

      var optionInputName =
        optionFieldKey(
          opt.option_name,
          j
        );

      var bodyControls =
        '';

      /* DROPDOWN */
      if (
        opt.option_type ===
        'dropdown'
      ) {
        bodyControls +=
          '<label class="visually-hidden" for="C' +
          j +
          '">' +
          escHtml(
            opt.option_name
          ) +
          '</label>';

        bodyControls +=
          '<select class="configuration-option-dropdown ' +
          opt.option_id +
          '" required name="' +
          optionInputName +
          '" id="C' +
          j +
          '">';

        bodyControls +=
          '<option value="" aria-selected="false">-- Choose ' +
          escHtml(
            opt.option_name
          ) +
          ' --</option>';

        for (
          var i = 0;
          i < opt.option_values.length;
          i++
        ) {
          var dropdownValue =
            opt.option_values[i];

          var optionAttrs = '';

          /*
           * IMPORTANT:
           * If Gild supplies a variant_id,
           * keep it on the actual DOM option.
           */
          if (
            dropdownValue.variant_id !=
              null &&
            String(
              dropdownValue.variant_id
            ).trim() !==
              ''
          ) {
            optionAttrs +=
              ' class="product-add-asso"' +
              ' data-variant-id="' +
              escHtml(
                String(
                  dropdownValue.variant_id
                )
              ) +
              '"';
          }

          var displayPrice = '';

          if (
            !isHingeFinishOptionName(opt.option_name) &&
            gildFlag(
              dropdownValue.adjust_price
            )
          ) {
            displayPrice =
              ' [+ ' +
              shop_currency +
              dropdownValue.variant_price +
              ']';
          }

          var dropdownValText = isHingeFinishOptionName(opt.option_name)
            ? stripOptionValuePriceSuffix(dropdownValue.option_value)
            : dropdownValue.option_value;

          bodyControls +=
            '<option value="' +
            escHtml(
              dropdownValue.option_value
            ) +
            '"' +
            optionAttrs +
            '>' +
            escHtml(
              dropdownValText
            ) +
            escHtml(
              displayPrice
            ) +
            '</option>';
        }

        bodyControls +=
          '</select>' +
          '<span id="S' +
          j +
          '" style="display:none;" class="required-span-text">This option is required.</span>';

        main_div_arr[j] =
          opt.option_id;
      }

      /* CHECKBOXES */
      if (
        opt.option_type ===
        'checkboxes'
      ) {
        for (
          var ci = 0;
          ci < opt.option_values.length;
          ci++
        ) {
          var checkboxInputId =
            configInputId(
              j,
              ci
            );

          var checkboxValue =
            String(
              opt.option_values[ci]
                .option_value
            );

          var checkboxClass =
            'custom-checkboxes';

          var checkboxVariantAttr =
            '';

          if (
            opt.option_values[ci]
              .variant_id != null &&
            String(
              opt.option_values[ci]
                .variant_id
            ).trim() !==
              ''
          ) {
            checkboxClass +=
              ' product-add-asso';

            checkboxVariantAttr =
              ' data-variant-id="' +
              escHtml(
                String(
                  opt.option_values[ci]
                    .variant_id
                )
              ) +
              '"';
          }

          var checkboxPrice =
            '';

          if (
            !isHingeFinishOptionName(opt.option_name) &&
            gildFlag(
              opt.option_values[ci]
                .adjust_price
            )
          ) {
            checkboxPrice =
              ' [+ ' +
              shop_currency +
              opt.option_values[ci]
                .variant_price +
              ']';
          }

          var checkboxValText = isHingeFinishOptionName(opt.option_name)
            ? stripOptionValuePriceSuffix(checkboxValue)
            : checkboxValue;

          bodyControls +=
            '<br><input type="checkbox" name="' +
            escHtml(
              checkboxValue
                .replace(
                  /\s+/g,
                  '-'
                )
                .toLowerCase() +
                '-' +
                j +
                ci
            ) +
            '" value="' +
            escHtml(
              checkboxValue
            ) +
            '" id="' +
            checkboxInputId +
            '" class="' +
            checkboxClass +
            '"' +
            checkboxVariantAttr +
            '>';

          bodyControls +=
            '<label for="' +
            checkboxInputId +
            '">' +
            escHtml(
              checkboxValText
            ) +
            escHtml(
              checkboxPrice
            ) +
            '</label>';
        }

        bodyControls +=
          '<span id="S' +
          j +
          '" style="display:none;" class="required-span-text">This option is required.</span>';

        main_div_arr[j] =
          opt.option_id;
      }

      /* SWATCHES */
      if (
        opt.option_type ===
        'swatches'
      ) {
        for (
          var si = 0;
          si < opt.option_values.length;
          si++
        ) {
          var ov =
            opt.option_values[si];

          var imgUrl =
            ov.image != null
              ? ov.image
              : 'https://form.doortodoorco.com/public/assets/images/no-image-sw.png';

          var gridAttr =
            opt.grid_type != null
              ? String(
                  opt.grid_type
                )
              : '';

          var swatchInputId =
            configInputId(
              j,
              si
            );

          /*
           * IMPORTANT CHANGE:
           *
           * Any Gild option value containing
           * variant_id becomes product-add-asso.
           *
           * We no longer require adjust_price,
           * variant_price or prehang text.
           */
          var swatchClasses =
            'custom-swatches focus-label';

          var linkedVariantAttrs =
            '';

          if (
            ov.variant_id != null &&
            String(
              ov.variant_id
            ).trim() !==
              ''
          ) {
            swatchClasses +=
              ' product-add-asso';

            linkedVariantAttrs +=
              ' data-variant-id="' +
              escHtml(
                String(
                  ov.variant_id
                )
              ) +
              '"';
          }

          if (
            ov.variant_price != null &&
            ov.variant_price !==
              ''
          ) {
            linkedVariantAttrs +=
              ' data-price="' +
              escHtml(
                ov.variant_price
              ) +
              '"';
          }

          bodyControls +=
            '<div class="box configuration-swatch-card" data-grid="' +
            escHtml(
              gridAttr
            ) +
            '">' +
            '<img src="' +
            escHtml(
              imgUrl
            ) +
            '" alt="">' +
            '<div class="tex-box">' +
            '<input type="radio" class="' +
            swatchClasses +
            '" name="' +
            escHtml(
              optionInputName
            ) +
            '"' +
            linkedVariantAttrs +
            ' value="' +
            escHtml(
              ov.option_value
            ) +
            '" id="' +
            swatchInputId +
            '">' +
            '<label class="custom-swatches-label" for="' +
            swatchInputId +
            '">' +
            escHtml(
              buildSwatchDisplayLabel(
                ov.option_value,
                ov,
                opt.option_name
              )
            ) +
            '</label>' +
            '</div>' +
            '</div>';
        }

        bodyControls +=
          '<span id="S' +
          j +
          '" style="display:none;" class="required-span-text">This option is required.</span>';

        main_div_arr[j] =
          opt.option_id;
      }

      /* TEXT */
      if (
        opt.option_type ===
        'text'
      ) {
        for (
          var ti = 0;
          ti < opt.option_values.length;
          ti++
        ) {
          bodyControls +=
            '<input type="text" style="display:none;" readonly name="' +
            optionInputName +
            '" value="' +
            escHtml(
              opt.option_values[ti]
                .option_value
            ) +
            '" class="custom-text"><span class="custom-text-span">' +
            escHtml(
              opt.option_values[ti]
                .option_value
            ) +
            '</span>';
        }

        bodyControls +=
          '<span id="S' +
          j +
          '" style="display:none;" class="required-span-text">This option is required.</span>';

        main_div_arr[j] =
          opt.option_id;
      }

      /* SHORT TEXT */
      if (
        opt.option_type ===
        'shorttext'
      ) {
        bodyControls +=
          '<label class="visually-hidden" for="Cst' +
          j +
          '">' +
          escHtml(
            opt.option_name
          ) +
          '</label>';

        bodyControls +=
          '<input type="text" name="' +
          optionInputName +
          '" id="Cst' +
          j +
          '" class="custom-shorttext">';

        bodyControls +=
          '<span id="S' +
          j +
          '" style="display:none;" class="required-span-text">This option is required.</span>';

        main_div_arr[j] =
          opt.option_id;
      }

      var titleInner =
        '<span class="configuration-option-title-text" id="config-option-label-' +
        j +
        '">' +
        escHtml(
          opt.option_name
        ) +
        '</span>' +
        (
          opt.is_required === 'Y'
            ? '<span class="configuration-option-required" aria-hidden="true">*</span>'
            : ''
        );

      var helpControlHtml =
        '';

      if (
        opt.help_text_display !==
          '0' &&
        opt.help_text != null &&
        String(
          opt.help_text
        ).trim() !==
          ''
      ) {
        var helpPopoverId =
          'config-help-' +
          j;

        var helpLabel =
          escHtml(
            getConfigHelpLabel(
              opt.option_name
            )
          );

        var closeLabel =
          escHtml(
            getConfigHelpCloseLabel()
          );

        helpControlHtml =
          '<button type="button" class="configuration-option-help-btn" popovertarget="' +
          helpPopoverId +
          '" aria-expanded="false" aria-controls="' +
          helpPopoverId +
          '" aria-label="' +
          helpLabel +
          '">' +
          '<span class="configuration-option-help-icon" aria-hidden="true">i</span>' +
          '</button>' +
          '<div id="' +
          helpPopoverId +
          '" popover="auto" class="configuration-option-help-popover" role="dialog" aria-label="' +
          helpLabel +
          '">' +
          '<button type="button" class="configuration-option-help-popover__close" popovertarget="' +
          helpPopoverId +
          '" popovertargetaction="hide" aria-label="' +
          closeLabel +
          '">' +
          '<span aria-hidden="true">&times;</span>' +
          '</button>' +
          '<div class="configuration-option-help-popover__content">' +
          opt.help_text +
          '</div>' +
          '</div>';
      }

      var chevronHtml =
        '<span class="configuration-option-chevron" aria-hidden="true"><svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" focusable="false" role="presentation" class="icon"><path class="h-line" d="M4 12h16"/><path class="v-line" d="M12 4v16"/></svg></span>';

      var displayStyle =
        j ===
        doorConfigurationOptionIndex
          ? 'display:block;'
          : 'display:none;';

      var bodyRole =
        opt.option_type ===
        'swatches'
          ? 'radiogroup'
          : 'group';

      var bodyAttrs =
        ' role="' +
        bodyRole +
        '" aria-label="' +
        escHtml(
          opt.option_name
        ) +
        '"';

      var blockHtml =
        '<div style="' +
        displayStyle +
        '" class="configuration-option-each main-' +
        j +
        '" data-option-index="' +
        j +
        '">' +
        '<div class="configuration-option-each__header">' +
        '<div class="configuration-option-each__title-row">' +
        '<button type="button" class="configuration-option-level configuration-option-toggle" id="L' +
        j +
        '" aria-expanded="true" aria-controls="config-body-' +
        j +
        '">' +
        '<span class="configuration-option-toggle__lead">' +
        titleInner +
        '</span></button>' +
        '<div class="configuration-option-each__title-actions">' +
        chevronHtml +
        helpControlHtml +
        '</div>' +
        '</div>' +
        '<span class="configuration-option-each__choice"></span>' +
        '</div>' +
        '<div class="configuration-option-each__body" id="config-body-' +
        j +
        '"' +
        bodyAttrs +
        '>' +
        bodyControls +
        '</div>' +
        '</div>';

      $optionsContainer.append(
        blockHtml
      );
    }
  }

  /* ============================================================
   * RULES
   * ============================================================ */

  function bindRulesOnChange(response) {
    var optionstid =
      response.option_set_id;

    function applyRulesFromValue(
      selectedValue,
      $trigger
    ) {
      var triggerIndex =
        getOptionIndexFromElement(
          $trigger
        );

      if (
        isNaN(
          triggerIndex
        )
      ) {
        return;
      }

      var nextIndex =
        triggerIndex + 1;

      var optionsLength =
        Object.keys(
          response.options
        ).length;

      temp_div_arr = [];

      for (
        var v = nextIndex;
        v < optionsLength;
        v++
      ) {
        var $mainDiv =
          getConfigurationOptionRow(
            v
          );

        if (
          $mainDiv.css(
            'display'
          ) ===
          'block'
        ) {
          temp_div_arr.push(
            v
          );
        }

        hideConfigurationOption(
          v
        );
      }

      if (
        selectedValue == null ||
        selectedValue === ''
      ) {
        enforceDoorConfigOptionVisibility(
          response
        );

        updateAddToCartButtonState();

        return;
      }

      var matchedRules =
        getOptionValueRules(
          response.options[
            triggerIndex
          ],
          selectedValue
        );

      var rulesApplied =
        applyOptionVisibilityRules(
          matchedRules,
          response
        );

      if (!rulesApplied) {
        var nextRelevant =
          findNextRelevantOptionIndex(
            nextIndex,
            response
          );

        if (
          nextRelevant !==
          -1
        ) {
          revealConfigurationOptionForDoorConfig(
            nextRelevant,
            response
          );
        }
      }

      if (
        $trigger.attr('id') ===
        'C9'
      ) {
        revealConfigurationOptionForDoorConfig(
          9,
          response
        );
      }

      if (
        String(optionstid) ===
        '1'
      ) {
        if (
          $trigger.attr('id') ===
          'C8'
        ) {
          if (
            $trigger.val() ===
            'Active Knob | 2-3/8 Boring (Can only be selected on 1 of 2 doors - not both.)'
          ) {
            $('#C9').hide();
            $('#L9').hide();

            hideConfigurationOption(
              9
            );

            $('#C10').show();
            $('#L10').show();

            revealConfigurationOptionForDoorConfig(
              10,
              response
            );
          }

          if (
            $trigger.val() ===
            'Ball Catch (No Bore for Dummy Knob - Knob Not Included)'
          ) {
            $('#C9').show();
            $('#L9').show();

            revealConfigurationOptionForDoorConfig(
              9,
              response
            );

            $('#C10').hide();
            $('#L10').hide();

            hideConfigurationOption(
              10
            );
          }
        }

        if (
          $trigger.attr('id') ===
          'C10'
        ) {
          revealConfigurationOptionForDoorConfig(
            10,
            response
          );

          $('#C10').show();
          $('#L10').show();

          hideConfigurationOption(
            9
          );

          $('#C9').hide();
          $('#L9').hide();
        }

        if (
          $trigger.attr('id') ===
          'C9'
        ) {
          revealConfigurationOptionForDoorConfig(
            9,
            response
          );

          $('#C9').show();
          $('#L9').show();

          hideConfigurationOption(
            10
          );

          $('#C10').hide();
          $('#L10').hide();
        }

        if (
          $(
            '#' +
              doorConfigurationSelectId()
          ).val() ===
          'Single Door'
        ) {
          hideConfigurationOption(
            8
          );

          hideConfigurationOption(
            9
          );

          hideConfigurationOption(
            10
          );
        }
      }

      enforceDoorConfigOptionVisibility(
        response
      );

      updateAddToCartButtonState();

      setTimeout(
        refreshDisplayedConfiguratorPrices,
        0
      );
    }

    $(document)
      .off(
        'change.gildSw',
        '.custom-swatches'
      )
      .on(
        'change.gildSw',
        '.custom-swatches',
        function () {
          if (
            gildSwatchSuppressChange
          ) {
            return;
          }

          var $t =
            $(this);

          console.log(
            '=== SWATCH SELECTED ===',
            {
              value:
                $t.val(),

              associated:
                $t.hasClass(
                  'product-add-asso'
                ),

              variantId:
                $t.attr(
                  'data-variant-id'
                )
            }
          );

          extra_price = 0;
          extra_value = 0;

          applyRulesFromValue(
            $t.val(),
            $t
          );

          setTimeout(function () {
            gildUpdatePricesFromDoorAndOptions(
              response
            );
          }, 0);
        }
      );

    $(document)
      .off(
        'change.gildDd',
        '.configuration-option-dropdown'
      )
      .on(
        'change.gildDd',
        '.configuration-option-dropdown',
        function () {
          var $t =
            $(this);

          var selectedID =
            $t.attr('id');

          var doorConfigSelectId =
            doorConfigurationSelectId();

          if (
            selectedID ===
            doorConfigSelectId
          ) {
            $('.configuration-option-dropdown')
              .not(
                '#' +
                  doorConfigSelectId
              )
              .each(function () {
                $(this).prop(
                  'selectedIndex',
                  0
                );

                $(this).attr(
                  'aria-selected',
                  'false'
                );
              });

            $(
              '#' +
                doorConfigSelectId
            ).attr(
              'aria-selected',
              'true'
            );
          }

          var $selectedOption =
            $t.find(
              'option:selected'
            );

          if (
            $selectedOption.attr(
              'data-variant-id'
            )
          ) {
            console.log(
              '=== DROPDOWN ASSOCIATED PRODUCT SELECTED ===',
              {
                variantId:
                  $selectedOption.attr(
                    'data-variant-id'
                  ),

                value:
                  $selectedOption.val()
              }
            );
          }

          applyRulesFromValue(
            $t.val(),
            $t
          );

          setTimeout(function () {
            gildDropdownPriceLogic(
              $t
            );
          }, 0);
        }
      );

    $(document)
      .off(
        'change.gildC9',
        '#C9'
      )
      .on(
        'change.gildC9',
        '#C9',
        function () {
          if (
            String(prsetid) ===
            '1'
          ) {
            revealConfigurationOptionForDoorConfig(
              9,
              response
            );
          }
        }
      );
  }

  function gildUpdatePricesFromDoorAndOptions(
    response
  ) {
    currentOptionsResponse =
      response ||
      currentOptionsResponse;

    refreshDisplayedConfiguratorPrices();
  }

  function gildDropdownPriceLogic(
    $changed
  ) {
    var doorConfigIndex =
      getDoorConfigurationOptionIndex();

    var $doorConfigRow =
      getConfigurationOptionRow(
        doorConfigIndex
      );

    if (
      !$doorConfigRow.length &&
      !$('#C0').length &&
      !$('.main-0 .custom-swatches').length
    ) {
      return;
    }

    var doorConfig =
      getDoorConfiguration();

    if (
      doorConfig ===
      'Single Door'
    ) {
      single_door_flag = 1;
    }

    if (
      doorConfig ===
      'Double Door'
    ) {
      single_door_flag = 2;
    }

    if (!doorConfig) {
      if (
        $changed.attr('id') ===
        doorConfigurationSelectId()
      ) {
        resetDisplayedPricesToBase();
      }

      return;
    }

    if (
      $changed.attr('id') ===
      doorConfigurationSelectId()
    ) {
      resetDisplayedPricesToBase(
        doorConfig
      );

      refreshDisplayedConfiguratorPrices();

      return;
    }

    refreshDisplayedConfiguratorPrices();
  }

  function prepareCustomResponse(
    response
  ) {
    var res_len =
      Object.keys(
        response.options
      ).length - 1;

    var custom_response =
      JSON.parse(
        JSON.stringify(response)
      );

    for (
      var u = res_len;
      u >= 0;
      u--
    ) {
      if (
        $('.main-' + u).css(
          'display'
        ) ===
          'none' ||
        !optionShouldBeVisible(
          u,
          response
        )
      ) {
        custom_response.options[
          u
        ].option_id = null;
      }
    }

    return custom_response;
  }

  function getCompanionCartProperties(
    custom_response
  ) {
    var props = {};

    if (
      !custom_response ||
      !custom_response.options
    ) {
      return props;
    }

    var doorConfig =
      getDoorConfiguration();

    if (!doorConfig) {
      return props;
    }

    var prehangIndex =
      getPrehangOptionIndex(
        custom_response,
        doorConfig
      );

    if (
      prehangIndex === -1 ||
      !isJambKitPrehangSelected(
        custom_response
      )
    ) {
      return props;
    }

    var opt =
      custom_response.options[
        prehangIndex
      ];

    var selected =
      getSelectedOptionValue(
        prehangIndex
      );

    if (
      opt &&
      opt.option_name &&
      selected
    ) {
      props[
        opt.option_name
      ] =
        normalizeOptionValue(
          selected
        );
    }

    return props;
  }

  function collectConfigurationData(
    custom_response
  ) {
    var each_option = [];
    var total_options_label = [];
    var total_options_required = [];
    var after_form_fill_total_options_required =
      [];
    var previous_checkbox_name = '';
    var previous_checkbox_value = '';
    var varient_arr = [];
    var validation_field = [];
    var c = 0;
    var checkboxes_array = [];
    var total_options =
      Object.keys(
        custom_response.options
      ).length;

    for (
      var index = 0;
      index < total_options;
      index++
    ) {
      total_options_label[index] =
        custom_response.options[
          index
        ].option_name;
    }

    for (
      var index = 0;
      index < total_options;
      index++
    ) {
      var $requiredRow =
        getConfigurationOptionRow(
          index
        );

      if (
        !$requiredRow.length ||
        !isConfiguratorOptionVisible(
          $requiredRow
        )
      ) {
        continue;
      }

      var requiredOpt =
        custom_response.options[
          index
        ];

      if (!requiredOpt) {
        continue;
      }

      var fieldKey =
        optionFieldKey(
          requiredOpt.option_name,
          index
        );

      if (
        requiredOpt.option_type ===
        'text'
      ) {
        total_options_required[
          fieldKey
        ] = 'Y';
      } else {
        total_options_required[
          fieldKey
        ] =
          requiredOpt.is_required;
      }
    }

    for (
      var ix = 0;
      ix < total_options;
      ix++
    ) {
      var j = ix;

      var opt =
        custom_response.options[
          ix
        ];

      if (!opt) {
        continue;
      }

      var $optionRow =
        getConfigurationOptionRow(
          ix
        );

      if (
        !$optionRow.length ||
        !isConfiguratorOptionVisible(
          $optionRow
        )
      ) {
        continue;
      }

      var optionField =
        optionFieldKey(
          opt.option_name,
          ix
        );

      if (
        opt.option_type ===
        'dropdown'
      ) {
        var dropdown_name =
          optionField;

        var dropdown_value =
          $optionRow
            .find(
              '.configuration-option-dropdown'
            )
            .val() ||
          $('#C' + ix).val() ||
          '';

        each_option[ix] = {
          name:
            dropdown_name,

          value:
            dropdown_value
        };

        after_form_fill_total_options_required[
          optionField
        ] =
          dropdown_value !== ''
            ? 'Y'
            : 'N';
      }

      if (
        opt.option_type ===
        'text'
      ) {
        var text_name =
          optionField;

        var text_value =
          $optionRow
            .find(
              'input.custom-text'
            )
            .val() ||
          '';

        each_option[ix] = {
          name:
            text_name,

          value:
            text_value
        };

        after_form_fill_total_options_required[
          optionField
        ] =
          text_value !== ''
            ? 'Y'
            : 'N';
      }

      if (
        opt.option_type ===
        'shorttext'
      ) {
        var short_text_name =
          optionField;

        var short_text_value =
          $optionRow
            .find(
              '.custom-shorttext'
            )
            .val() ||
          '';

        each_option[ix] = {
          name:
            short_text_name,

          value:
            short_text_value
        };

        after_form_fill_total_options_required[
          optionField
        ] =
          short_text_value !== ''
            ? 'Y'
            : 'N';
      }

      if (
        opt.option_type ===
        'swatches'
      ) {
        var swatch_name =
          optionField;

        var swatch_value =
          $optionRow
            .find(
              '.custom-swatches:checked'
            )
            .val();

        each_option[ix] = {
          name:
            swatch_name,

          value:
            swatch_value
        };

        after_form_fill_total_options_required[
          optionField
        ] =
          typeof swatch_value !==
            'undefined' &&
          swatch_value !== ''
            ? 'Y'
            : 'N';
      }

      if (
        opt.option_type ===
        'checkboxes'
      ) {
        var checkbox_name =
          optionField;

        var g = 0;

        checkboxes_array = [];

        for (
          var i = 0;
          i <
          Object.keys(
            opt.option_values
          ).length;
          i++
        ) {
          var checkbox_option_name =
            opt.option_values[
              i
            ].option_value
              .replace(
                /\s+/g,
                '-'
              )
              .toLowerCase() +
            '-' +
            j +
            i;

          if (
            after_form_fill_total_options_required[
              checkbox_name
            ] !==
            'Y'
          ) {
            after_form_fill_total_options_required[
              checkbox_name
            ] = 'N';
          }

          if (
            checkbox_name ===
            previous_checkbox_name
          ) {
            if (
              $('input[name="' +
                checkbox_option_name +
                '"]').prop(
                'checked'
              ) === true
            ) {
              var checkbox_value =
                $(
                  'input[name="' +
                    checkbox_option_name +
                    '"]'
                ).val();

              if (
                previous_checkbox_value ===
                ''
              ) {
                previous_checkbox_value =
                  previous_checkbox_value +
                  checkbox_value;

                checkboxes_array[
                  g
                ] = i;

                g++;
              } else {
                previous_checkbox_value =
                  previous_checkbox_value +
                  ', ' +
                  checkbox_value;

                checkboxes_array[
                  g
                ] = i;

                g++;
              }

              each_option[ix] = {
                name:
                  checkbox_name,

                value:
                  previous_checkbox_value
              };

              after_form_fill_total_options_required[
                checkbox_name
              ] = 'Y';
            }
          } else {
            if (
              $('input[name="' +
                checkbox_option_name +
                '"]').prop(
                'checked'
              ) === true
            ) {
              var checkbox_value =
                $(
                  'input[name="' +
                    checkbox_option_name +
                    '"]'
                ).val();

              previous_checkbox_value =
                checkbox_value;

              each_option[ix] = {
                name:
                  checkbox_name,

                value:
                  checkbox_value
              };

              after_form_fill_total_options_required[
                checkbox_name
              ] = 'Y';

              checkboxes_array[
                g
              ] = i;

              g++;
            }
          }

          previous_checkbox_name =
            checkbox_name;
        }

        previous_checkbox_value =
          '';

        previous_checkbox_name =
          '';
      }
    }

    /*
     * DYNAMIC ASSOCIATED PRODUCTS
     */
    varient_arr =
      collectAssociatedVariantIds(
        custom_response
      );

    for (
      var key in
      total_options_required
    ) {
      if (
        total_options_required[
          key
        ] === 'Y'
      ) {
        if (
          total_options_required[
            key
          ] !==
          after_form_fill_total_options_required[
            key
          ]
        ) {
          validation_field[c] =
            key;

          c++;
        }
      }
    }

    return {
      each_option:
        each_option,

      total_options_label:
        total_options_label,

      varient_arr:
        varient_arr,

      validation_field:
        validation_field
    };
  }

  /* ============================================================
   * CART / ATC
   * ============================================================ */

  function getMainAddToCartButton() {
    return (
      document.querySelector(
        '.js-product-form-main button[name="add"]'
      ) ||
      document.querySelector(
        'form.js-product-form button[name="add"]'
      )
    );
  }

  function setAddToCartPendingState(
    pending
  ) {
    var btn =
      getMainAddToCartButton();

    if (
      !btn ||
      hasGildConfiguration
    ) {
      return;
    }

    if (pending) {
      btn.setAttribute(
        'data-gild-configurator-pending',
        'true'
      );

      btn.disabled = true;

      btn.textContent =
        btn.dataset.preselectionText ||
        'Make a selection';

      return;
    }

    btn.removeAttribute(
      'data-gild-configurator-pending'
    );
  }

  function releaseToStandardAddToCart() {
    hasGildConfiguration =
      false;

    currentOptionsResponse =
      null;

    var btn =
      getMainAddToCartButton();

    if (!btn) return;

    btn.removeAttribute(
      'data-gild-configurator-submit'
    );

    btn.removeAttribute(
      'data-gild-configurator-pending'
    );

    var vp =
      document.querySelector(
        'variant-picker'
      );

    if (
      vp &&
      typeof vp.updateAddToCartButton ===
        'function'
    ) {
      vp.updateAddToCartButton();
    } else {
      var form =
        document.querySelector(
          '.js-product-form-main'
        );

      var idInput =
        form &&
        form.querySelector(
          'input[name="id"]'
        );

      var addToCartText =
        btn.dataset.addToCartText ||
        'Add to cart';

      if (
        idInput &&
        idInput.value
      ) {
        btn.disabled =
          false;

        btn.textContent =
          addToCartText;
      }
    }

    document.dispatchEvent(
      new CustomEvent(
        'product:add-to-cart-state-updated'
      )
    );
  }

  function activateGildConfigurator(
    response
  ) {
    hasGildConfiguration =
      true;

    currentOptionsResponse =
      response;

    ensureGildSubmitButtonState();

    updateAddToCartButtonState();
  }

  function getVariantPickerBlocker(
    btn
  ) {
    var vp =
      document.querySelector(
        'variant-picker'
      );

    if (!vp) return null;

    var strings =
      window.theme &&
      window.theme.strings
        ? window.theme.strings
        : {};

    if (
      !vp.classList.contains(
        'variant-picker--product-available'
      )
    ) {
      return {
        text:
          strings.noStock ||
          'Sold out'
      };
    }

    if (
      vp.classList.contains(
        'variant-picker--preselection'
      )
    ) {
      return {
        text:
          (btn &&
            btn.dataset.preselectionText) ||
          strings.noSelectedVariant ||
          'Make a selection'
      };
    }

    if (
      lastVariantFromPicker &&
      lastVariantFromPicker.available ===
        false
    ) {
      return {
        text:
          strings.noStock ||
          'Sold out'
      };
    }

    return null;
  }

  function showRequiredOptionMessages(
    validation_field
  ) {
    $('.required-span-text').hide();

    for (
      var vi = 0;
      vi < validation_field.length;
      vi++
    ) {
      var optionIndex =
        getOptionIndexFromFieldKey(
          validation_field[vi]
        );

      var $span =
        $('#S' + optionIndex);

      var $row =
        $span.closest(
          '.configuration-option-each'
        );

      if ($row.length) {
        setRowCollapsed(
          $row,
          false
        );
      }

      $span.css({
        display: 'block'
      });
    }

    showConfiguratorError(
      'Please complete all required configuration options.'
    );
  }

  function updateAddToCartButtonState() {
    if (
      !hasGildConfiguration
    ) {
      return;
    }

    var btn =
      getMainAddToCartButton();

    if (!btn) {
      return;
    }

    var addToCartText =
      btn.dataset.addToCartText ||
      'Add to cart';

    var preselectionText =
      btn.dataset.preselectionText ||
      'Make a selection';

    var variantBlocker =
      getVariantPickerBlocker(
        btn
      );

    if (variantBlocker) {
      btn.disabled = true;
      btn.textContent =
        variantBlocker.text;

      return;
    }

    if (
      !currentOptionsResponse ||
      !currentOptionsResponse.options
    ) {
      btn.disabled = true;
      btn.textContent =
        preselectionText;

      return;
    }

    var configData =
      collectConfigurationData(
        prepareCustomResponse(
          currentOptionsResponse
        )
      );

    if (
      configData.validation_field
        .length > 0
    ) {
      btn.disabled = true;
      btn.textContent =
        addToCartText;

      document.dispatchEvent(
        new CustomEvent(
          'product:add-to-cart-state-updated'
        )
      );

      return;
    }

    btn.disabled = false;
    btn.textContent =
      addToCartText;

    document.dispatchEvent(
      new CustomEvent(
        'product:add-to-cart-state-updated'
      )
    );
  }

  function initAddToCartButtonWatcher() {
    var vpScript =
      document.querySelector(
        'variant-picker script[type="application/json"]'
      );

    if (vpScript) {
      try {
        lastVariantFromPicker =
          JSON.parse(
            vpScript.textContent
          );
      } catch (e) {
        lastVariantFromPicker =
          null;
      }
    }

    document.addEventListener(
      'on:variant:change',
      function (evt) {
        lastVariantFromPicker =
          evt.detail &&
          evt.detail.variant
            ? evt.detail.variant
            : null;

        captureUnitPricesFromVariant(
          lastVariantFromPicker
        );

        syncConfiguratorVariantContext();

        scheduleLoadOptionset(false);

        setTimeout(function () {
          recalculateConfiguratorPrices();

          applyDoubleHandlePreparationRules(
            currentOptionsResponse
          );

          ensureGildSubmitButtonState();

          updateAddToCartButtonState();
        }, 0);
      }
    );

    $(document)
      .off(
        'change.gildAtc input.gildAtc',
        '#api-response'
      )
      .on(
        'change.gildAtc input.gildAtc',
        '#api-response select, #api-response .custom-swatches, #api-response .custom-checkboxes, #api-response .custom-shorttext',
        function () {
          $('.required-span-text').hide();

          updateAddToCartButtonState();
        }
      );

    $(document)
      .off(
        'blur.gildAtc',
        '#api-response .custom-shorttext'
      )
      .on(
        'blur.gildAtc',
        '#api-response .custom-shorttext',
        function () {
          updateAddToCartButtonState();
        }
      );
  }

  window.gildUpdateAddToCartButtonState =
    updateAddToCartButtonState;

  function buildConfiguratorCartItems(
    variantId,
    qty,
    propertiesValue,
    doubleDoorFlag,
    associatedVariantIds,
    configuredTotalOverride,
    customResponse
  ) {
    var configGroupId =
      String(id);

    var items = [];

    var configuredTotal =
      typeof configuredTotalOverride ===
        'number' &&
      configuredTotalOverride > 0
        ? configuredTotalOverride
        : getConfiguredCartTotal();

    var mainProperties =
      Object.assign(
        {},
        propertiesValue,
        {
          ID:
            configGroupId
        },
        buildGildLineItemPricingProperties(
          configuredTotal
        )
      );

    var companionProperties =
      Object.assign(
        {
          ID:
            configGroupId
        },
        getCompanionCartProperties(
          customResponse ||
            currentOptionsResponse
        )
      );

    if (
      configuredTotal >
      0
    ) {
      mainProperties[
        '_Configured Total'
      ] =
        formatMoneyAmount(
          configuredTotal
        );
    }

    /*
     * ASSOCIATED PRODUCTS
     */
    (
      associatedVariantIds || []
    ).forEach(function (
      assocVariantId
    ) {
      var normalizedId =
        normalizeCartVariantId(
          assocVariantId
        );

      if (!normalizedId) {
        return;
      }

      items.push({
        id:
          normalizedId,

        quantity:
          Number(qty),

        properties:
          companionProperties
      });

      console.log(
        '=== ASSOCIATED PRODUCT ADDED TO PAYLOAD ===',
        {
          variantId:
            normalizedId,

          quantity:
            Number(qty)
        }
      );
    });

    /*
     * DOUBLE DOOR SECOND MAIN PRODUCT
     */
    if (
      doubleDoorFlag === 'Y'
    ) {
      items.push({
        id:
          normalizeCartVariantId(
            variantId
          ),

        quantity:
          Number(qty),

        properties: {
          ID:
            configGroupId,

          'Double Door':
            'DO NOT DELETE. This is the second door in your double door order. Any customizations, including jamb kits, are included in the price of the first door.'
        }
      });
    }

    /*
     * MAIN PRODUCT
     */
    items.push({
      id:
        normalizeCartVariantId(
          variantId
        ),

      quantity:
        Number(qty),

      properties:
        mainProperties
    });

    console.log(
      '=== COMPLETE CART ITEMS ===',
      items
    );

    return items;
  }

  function handleGildAddToCart() {
    if (
      !hasGildConfiguration
    ) {
      return;
    }

    var btn =
      getMainAddToCartButton();

    if (
      btn &&
      btn.disabled
    ) {
      return;
    }

    showConfiguratorError('');

    if (
      currentOptionsResponse
    ) {
      var cachedConfigData =
        collectConfigurationData(
          prepareCustomResponse(
            currentOptionsResponse
          )
        );

      if (
        cachedConfigData
          .validation_field
          .length > 0
      ) {
        showRequiredOptionMessages(
          cachedConfigData.validation_field
        );

        return;
      }
    }

    setConfiguratorSubmitLoading(
      true
    );

    var apiVariantId =
      getGildVariantIdForApi();

    if (!apiVariantId) {
      setConfiguratorSubmitLoading(
        false
      );

      showConfiguratorError(
        'Select a door size before adding to cart.'
      );

      updateAddToCartButtonState();

      return;
    }

    var data = {
      product_id:
        apiVariantId
    };

    gildApiPost(
      API_OPTIONS,
      data
    )
      .done(function (
        response
      ) {
        response =
          parseGildOptionsResponse(
            response
          );

        var apiError =
          getGildResponseError(
            response
          );

        if (
          apiError ||
          getOptionsCount(
            response
          ) === 0
        ) {
          setConfiguratorSubmitLoading(
            false
          );

          showConfiguratorError(
            apiError ||
              'Unable to load this configuration. Please refresh and try again.'
          );

          updateAddToCartButtonState();

          return;
        }

        prsetid =
          response.option_set_id;

        var custom_response =
          prepareCustomResponse(
            response
          );

        var configData =
          collectConfigurationData(
            custom_response
          );

        var each_option =
          configData.each_option;

        var total_options_label =
          configData.total_options_label;

        var validation_field =
          configData.validation_field;

        var variantId =
          apiVariantId;

        var qty =
          $('.js-product-form-main')
            .find(
              "input[name='quantity']"
            )
            .val() ||
          '1';

        if (
          validation_field.length !==
          0
        ) {
          setConfiguratorSubmitLoading(
            false
          );

          showRequiredOptionMessages(
            validation_field
          );

          updateAddToCartButtonState();

          return;
        }

        var properties_each_value =
          [];

        var double_door_flag =
          'N';

        var label;
        var value;

        for (
          var k in each_option
        ) {
          if (
            !each_option.hasOwnProperty(
              k
            )
          ) {
            continue;
          }

          if (
            !each_option[k] ||
            each_option[k].value ==
              null ||
            each_option[k].value ===
              ''
          ) {
            continue;
          }

          label =
            total_options_label[
              k
            ];

          value =
            each_option[k].value;

          if (
            normalizeDoorConfiguration(
              value
            ) ===
            'Double Door'
          ) {
            double_door_flag =
              'Y';
          }

          properties_each_value[
            label
          ] =
            value;
        }

        var properties_value =
          Object.assign(
            {},
            properties_each_value
          );

        currentOptionsResponse =
          response;

        cacheActiveVariantPrice();

        var chargeable =
          calculateChargeableTotal(
            response
          );

        var configuredTotal =
          chargeable.total;

        updateDisplayedPrices(
          configuredTotal.toFixed(
            2
          ),
          chargeable.compareTotal.toFixed(
            2
          )
        );

        if (
          configuredTotal >
          0
        ) {
          $('#product-extra').val(
            formatMoneyAmount(
              configuredTotal
            )
          );
        }

        /*
         * ================================================
         * FULLY DYNAMIC ASSOCIATED PRODUCT COLLECTION
         * ================================================
         */
        var associatedVariantIds =
          getSelectedAssociatedVariantIds();

        console.log(
          '=== FINAL ASSOCIATED VARIANTS BEFORE CART ===',
          associatedVariantIds
        );

        var unchargedOptions =
          getUnchargedConfiguredOptions(
            custom_response,
            associatedVariantIds
          );

        if (
          unchargedOptions.length >
          0
        ) {
          console.warn(
            'Gild configurator: the following priced options are not linked to Shopify variants:',
            unchargedOptions
          );
        }

        var dynamicObjects =
          buildConfiguratorCartItems(
            variantId,
            qty,
            properties_value,
            double_door_flag,
            associatedVariantIds,
            configuredTotal,
            custom_response
          );

        console.log(
          '=== FINAL CART REQUEST PAYLOAD ===',
          JSON.stringify(
            {
              items:
                dynamicObjects
            },
            null,
            2
          )
        );

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify({
            items: dynamicObjects
          }),
          dataType: 'json',
          contentType: 'application/json',

          success: function (response) {
            console.log(
              '=== SHOPIFY CART ADD SUCCESS ===',
              response
            );

            console.log(
              '=== CART ITEMS AFTER ADD ==='
            );

            $.getJSON('/cart.js')
              .done(function (cart) {
                console.log(
                  '=== CURRENT SHOPIFY CART ===',
                  cart.items
                );

                cart.items.forEach(function (item) {
                  console.log(
                    'CART ITEM:',
                    {
                      id: item.id,
                      title: item.title,
                      quantity: item.quantity,
                      properties: item.properties
                    }
                  );
                });
              })
              .fail(function (xhr) {
                console.error(
                  'Unable to read cart:',
                  xhr
                );
              });

            setConfiguratorSubmitLoading(false);

            /*
            * Keep redirect disabled.
            */
            window.location.href = '/cart';

            document.dispatchEvent(
              new CustomEvent(
                'product:add-to-cart-state-updated'
              )
            );

            document.dispatchEvent(
              new CustomEvent(
                'cart:updated'
              )
            );
          },

          error: function (xhr) {
            console.error(
              '=== SHOPIFY CART ADD ERROR ==='
            );

            console.error(
              'Status:',
              xhr.status
            );

            console.error(
              'Response:',
              xhr.responseText
            );

            console.error(
              'JSON:',
              xhr.responseJSON
            );

            console.error(
              'Payload that was sent:',
              dynamicObjects
            );

            setConfiguratorSubmitLoading(false);

            var message =
              'Unable to add this configuration to your cart.';

            if (
              xhr.responseJSON &&
              xhr.responseJSON.description
            ) {
              message =
                xhr.responseJSON.description;
            }

            showConfiguratorError(message);

            updateAddToCartButtonState();
          }
        });
      })
      .fail(function (
        xhr
      ) {
        console.error(
          'Gild configurator request failed:',
          xhr
        );

        setConfiguratorSubmitLoading(
          false
        );

        showConfiguratorError(
          'Unable to load product configuration. Please refresh and try again.'
        );

        updateAddToCartButtonState();
      });
  }

  function initGildCartSubmit() {
    if (
      initGildCartSubmit.bound
    ) {
      return;
    }

    initGildCartSubmit.bound =
      true;

    document.addEventListener(
      'submit',
      function (event) {
        if (
          !hasGildConfiguration
        ) {
          return;
        }

        var form =
          event.target;

        if (
          !form ||
          !form.classList ||
          !form.classList.contains(
            'js-product-form-main'
          )
        ) {
          return;
        }

        event.preventDefault();

        event.stopImmediatePropagation();

        handleGildAddToCart();
      },
      true
    );
  }

  function wireCartSubmit() {
    initGildCartSubmit();

    ensureGildSubmitButtonState();
  }

  /* ============================================================
   * OPTIONS LOADING
   * ============================================================ */

  function handleOptionsetLoaded(
    response,
    apiProductId,
    requestToken
  ) {
    configuratorApiProductId =
      String(apiProductId);

    var styleData = {
      product_id:
        configuratorApiProductId
    };

    activateGildConfigurator(
      response
    );

    prsetid =
      response.option_set_id;

    buildOptionsMarkup(
      response
    );

    expandDoorConfigurationRow(
      response
    );

    captureUnitPricesFromVariant(
      lastVariantFromPicker
    );

    bindRulesOnChange(
      response
    );

    wireCartSubmit();

    initCollapsibleOptions();

    initConfigurationHelpPopovers();

    revealConfiguratorPanel();

    var $doorSelect =
      $('#' +
        doorConfigurationSelectId());

    if (
      $doorSelect.length &&
      $doorSelect.val()
    ) {
      $doorSelect.trigger(
        'change'
      );
    }

    applyOptionStyles(
      styleData
    );

    ensureGildSubmitButtonState();

    updateAddToCartButtonState();

    var initialPricingVariantIds =
      collectVariantIdsFromOptionsResponse(
        response
      );

    var mainVariantId =
      getMainVariantIdForPricing();

    if (
      mainVariantId &&
      initialPricingVariantIds.indexOf(
        mainVariantId
      ) === -1
    ) {
      initialPricingVariantIds.push(
        mainVariantId
      );
    }

    loadShopifyVariantPrices(
      initialPricingVariantIds
    ).always(
      function () {
        if (
          requestToken !==
            optionsRequestToken ||
          !currentOptionsResponse
        ) {
          return;
        }

        refreshDisplayedConfiguratorPrices();
      }
    );

    $(document)
      .off(
        'change.gildCb',
        '.custom-checkboxes'
      )
      .on(
        'change.gildCb',
        '.custom-checkboxes',
        function () {
          refreshDisplayedConfiguratorPrices();
        }
      );

    $(document)
      .off(
        'change.gildPrice',
        '#api-response'
      )
      .on(
        'change.gildPrice',
        '#api-response .custom-swatches, #api-response .configuration-option-dropdown, #api-response .custom-checkboxes',
        function () {
          setTimeout(
            refreshDisplayedConfiguratorPrices,
            0
          );
        }
      );
  }

  function requestOptionsetFrom(
    url,
    apiProductId
  ) {
    return gildApiPost(
      url,
      {
        product_id:
          apiProductId
      }
    ).then(
      function (raw) {
        var parsed =
          parseGildOptionsResponse(
            raw
          );

        if (parsed) {
          return parsed;
        }

        return $.Deferred()
          .reject({
            responseText:
              'Invalid configurator response'
          })
          .promise();
      }
    );
  }

  function requestOptionset(
    apiProductId
  ) {
    return requestOptionsetFrom(
      API_OPTIONS,
      apiProductId
    );
  }

  function scheduleLoadOptionset(
    skipClear
  ) {
    window.clearTimeout(
      loadOptionsetTimer
    );

    loadOptionsetTimer =
      window.setTimeout(
        function () {
          loadOptionset(
            skipClear
          );
        },
        100
      );
  }

  function loadOptionset(
    skipClear
  ) {
    var variantId =
      getGildVariantIdForApi();

    productId =
      variantId;

    if (!variantId) {
      pendingConfiguratorLoad =
        true;

      return;
    }

    pendingConfiguratorLoad =
      false;

    configuratorApiProductId =
      '';

    var requestToken =
      ++optionsRequestToken;

    showConfiguratorLoadingState();

    function finishWithError(
      message
    ) {
      console.warn(
        'Gild configurator:',
        message,
        {
          variantId:
            variantId
        }
      );

      showConfiguratorUnavailableState(
        message
      );

      releaseToStandardAddToCart();
    }

    requestOptionset(
      variantId
    )
      .done(function (response) {
        if (
          requestToken !==
          optionsRequestToken
        ) {
          return;
        }

        var apiError =
          getGildResponseError(
            response
          );

        var optionsCount =
          getOptionsCount(
            response
          );

        if (
          apiError &&
          optionsCount === 0
        ) {
          finishWithError(
            apiError
          );

          return;
        }

        if (
          optionsCount === 0
        ) {
          finishWithError(
            'Configuration options are unavailable for this variant.'
          );

          return;
        }

        try {
          handleOptionsetLoaded(
            response,
            variantId,
            requestToken
          );
        } catch (err) {
          console.error(
            'Gild configurator render failed for variant',
            variantId,
            err
          );

          finishWithError(
            'Unable to render door configuration. Please refresh and try again.'
          );
        }
      })
      .fail(function (xhr) {
        if (
          requestToken !==
          optionsRequestToken
        ) {
          return;
        }
        
        console.error(
          'Gild configurator request failed for variant',
          variantId,
          xhr
        );

        finishWithError(
          'Unable to load door configuration. Please refresh and try again.'
        );
      });

    if (!skipClear) {
      count_odd_even++;
    }
  }

  function bootstrapConfiguratorLoad(
    attempt
  ) {
    attempt =
      attempt || 0;

    syncConfiguratorVariantContext();

    if (
      getGildVariantIdForApi()
    ) {
      scheduleLoadOptionset(
        true
      );

      return;
    }

    pendingConfiguratorLoad =
      true;

    if (attempt === 0) {
      showConfiguratorLoadingState();
    }

    if (
      attempt >= 8
    ) {
      showConfiguratorUnavailableState(
        'Select a size to load door configuration options.'
      );

      return;
    }

    window.setTimeout(
      function () {
        syncConfiguratorVariantContext();

        if (
          getGildVariantIdForApi() &&
          (
            pendingConfiguratorLoad ||
            !hasGildConfiguration
          )
        ) {
          scheduleLoadOptionset(
            true
          );

          return;
        }

        bootstrapConfiguratorLoad(
          attempt + 1
        );
      },
      attempt < 3
        ? 150
        : 400
    );
  }

  /* ============================================================
   * DEBUG FUNCTIONS
   * ============================================================ */

  window.reloadGildConfigurator =
    function () {
      scheduleLoadOptionset(
        false
      );
    };

  window.debugGildConfigurator =
    function (apiProductId) {
      var debugId =
        apiProductId ||
        getGildVariantIdForApi() ||
        getConfiguratorApiProductId();

      return requestOptionset(
        debugId
      ).then(
        function (response) {
          console.info(
            'Gild configurator debug response for',
            debugId,
            response
          );

          return response;
        },
        function (xhr) {
          console.error(
            'Gild configurator debug failed for',
            debugId,
            xhr
          );

          return xhr;
        }
      );
    };

  /*
   * Run in console after selecting the associated product:
   *
   * debugSelectedAssociatedVariants()
   */
  window.debugSelectedAssociatedVariants =
    function () {
      var ids =
        getSelectedAssociatedVariantIds();

      console.log(
        '=== DEBUG SELECTED ASSOCIATED VARIANTS ===',
        ids
      );

      return ids;
    };

  /* ============================================================
   * DOCUMENT READY
   * ============================================================ */

  $(document).ready(function () {
    if (
      !isDoorConfigurationEnabled() ||
      !$('#api-response').length ||
      !$('#product-fst-id').length
    ) {
      return;
    }

    setAddToCartPendingState(
      true
    );

    initAddToCartButtonWatcher();

    initGildCartSubmit();

    captureUnitPricesFromVariant(
      lastVariantFromPicker
    );

    $('.js-product-form-main')
      .find(
        'input[name="Width"]'
      )
      .on(
        'change',
        function () {
          setTimeout(
            function () {
              captureUnitPricesFromVariant(
                lastVariantFromPicker
              );

              recalculateConfiguratorPrices();

              applyDoubleHandlePreparationRules(
                currentOptionsResponse
              );
            },
            100
          );
        }
      );

    $('.js-product-form-main')
      .find(
        'input[name="Height"]'
      )
      .on(
        'change',
        function () {
          setTimeout(
            function () {
              captureUnitPricesFromVariant(
                lastVariantFromPicker
              );

              recalculateConfiguratorPrices();
            },
            100
          );
        }
      );

    $(document).on(
      'change',
      'select[name="options[Jamb Kit Width]"]',
      function () {
        setTimeout(
          function () {
            captureUnitPricesFromVariant(
              lastVariantFromPicker
            );

            recalculateConfiguratorPrices();
          },
          100
        );
      }
    );

    gildApiPost(
      API_STYLE,
      {
        product_id:
          getGildVariantIdForApi()
      }
    );

    bootstrapConfiguratorLoad();
  });
})(jQuery);